(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1947,6244],{

/***/ 73396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* reexport */ FilterDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-animate-height/dist/esm/index.js
var esm = __webpack_require__(29244);
// EXTERNAL MODULE: ./components/search/search.module.scss
var search_module = __webpack_require__(18149);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/search/FilterDropdown/FilterDropdown.tsx








var Icon = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var FilterDropdown = function(param) {
    var title = param.title, children = param.children, _isFilterOpen = param.isFilterOpen, isFilterOpen = _isFilterOpen === void 0 ? false : _isFilterOpen, _isFilterDisabled = param.isFilterDisabled, isFilterDisabled = _isFilterDisabled === void 0 ? false : _isFilterDisabled, _hasSelectedOptions = param.hasSelectedOptions, hasSelectedOptions = _hasSelectedOptions === void 0 ? false : _hasSelectedOptions, toggleFilter = param.toggleFilter, _selectedOptions = param.selectedOptions, selectedOptions = _selectedOptions === void 0 ? [
        "All"
    ] : _selectedOptions, _maximumNumberOfVisibleSelectedOptions = param.maximumNumberOfVisibleSelectedOptions, maximumNumberOfVisibleSelectedOptions = _maximumNumberOfVisibleSelectedOptions === void 0 ? 3 : _maximumNumberOfVisibleSelectedOptions, _hasSpacingBottom = param.hasSpacingBottom, hasSpacingBottom = _hasSpacingBottom === void 0 ? true : _hasSpacingBottom;
    var selectedOptionsRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).filter,
        "data-has-spacing-bottom": hasSpacingBottom,
        "data-is-open": isFilterOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "".concat((search_module_default()).header).concat(!(0,utilities_system/* isProd */.BB)() ? " search__dropdown-button search__dropdown-button-".concat((0,search/* filterClassName */.h1)(title)) : ""),
                type: "button",
                disabled: isFilterDisabled,
                onClick: toggleFilter,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (search_module_default()).text,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (search_module_default()).name,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (search_module_default()).selected,
                                "data-has-selections": hasSelectedOptions,
                                ref: selectedOptionsRef,
                                children: [
                                    selectedOptions.slice(0, maximumNumberOfVisibleSelectedOptions).join(", "),
                                    maximumNumberOfVisibleSelectedOptions < selectedOptions.length ? " + ".concat(selectedOptions.length - maximumNumberOfVisibleSelectedOptions) : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        customClass: (search_module_default()).chevron,
                        name: "ChevronDown",
                        size: system/* Size.Large */.$u.Large
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                height: isFilterOpen ? "auto" : 0,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/FilterDropdown/index.ts



/***/ }),

/***/ 91947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SearchFilters; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/search/search.module.scss
var search_module = __webpack_require__(18149);
var search_module_default = /*#__PURE__*/__webpack_require__.n(search_module);
// EXTERNAL MODULE: ./components/styleguide/Icon/index.ts + 1 modules
var Icon = __webpack_require__(56244);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/search/FilterCategory/FilterCategory.tsx




var FilterCategory = function(param) {
    var header = param.header, icon = param.icon, children = param.children, hasBorderBottom = param.hasBorderBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((search_module_default()).category, " ").concat(hasBorderBottom ? (search_module_default())["with-border"] : ""),
        children: [
            header && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (search_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (search_module_default()).text,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: (search_module_default()).title,
                        children: [
                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon["default"], {
                                name: icon,
                                customClass: (search_module_default()).icon,
                                size: system/* Size.Large */.$u.Large
                            }),
                            header
                        ]
                    })
                })
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/FilterCategory/index.ts


;// CONCATENATED MODULE: ./components/search/FilterPackage/FilterPackage.tsx


var FilterPackage = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_module_default())["package"],
        children: children
    });
};

;// CONCATENATED MODULE: ./components/search/FilterPackage/index.ts


// EXTERNAL MODULE: ./components/search/FilterDropdown/index.ts + 1 modules
var FilterDropdown = __webpack_require__(73396);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./store/selectors/search.js
var selectors_search = __webpack_require__(29906);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/search/filters/Alloys/Alloys.tsx










var Alloys_Icon = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Alloys = function(param) {
    var isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange;
    var availableSpec = (0,es/* useSelector */.v9)(selectors_search/* selectSpecSearchFilter */.bn);
    var selectedSpec = (0,es/* useSelector */.v9)(selectors_search/* selectFullActiveSpec */.j4);
    var ref = (0,react.useState)([]), availableAlloys = ref[0], setAvailableAlloys = ref[1];
    var ref1 = (0,react.useState)(undefined), selectedAlloys = ref1[0], setSelectedAlloys = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        setAvailableAlloys(((ref = availableSpec.filter(function(spec) {
            return spec.name === "Alloys";
        })[0]) === null || ref === void 0 ? void 0 : ref.subFilters) || []);
    }, [
        availableSpec
    ]);
    (0,react.useEffect)(function() {
        setSelectedAlloys(selectedSpec.filter(function(spec) {
            return spec.filter === "Alloys";
        })[0]);
    }, [
        selectedSpec
    ]);
    var onChangeSelect = function(event) {
        if (selectedAlloys) {
            var selectedId = availableAlloys.filter(function(available) {
                return selectedAlloys.id === available.id;
            })[0].id;
            onChange({
                type: "multi",
                value: selectedId,
                filter: constants/* FILTER_SPEC */.q9
            });
        }
        if (event.currentTarget.value === "") {
            setSelectedAlloys(undefined);
        } else {
            onChange({
                type: "multi",
                value: parseInt(event.currentTarget.value),
                filter: constants/* FILTER_SPEC */.q9
            });
            setSelectedAlloys(availableAlloys.filter(function(available) {
                return parseInt(event.currentTarget.value) === available.id;
            })[0]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Alloys",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: !!selectedAlloys,
        selectedOptions: selectedAlloys ? [
            "Minimum ".concat(selectedAlloys.name, " inch")
        ] : [
            "All"
        ],
        children: availableAlloys.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_module_default()).select,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                    onChange: onChangeSelect,
                    defaultValue: "",
                    value: (selectedAlloys === null || selectedAlloys === void 0 ? void 0 : selectedAlloys.id) || "",
                    className: "".concat((search_module_default()).control).concat(!(0,utilities_system/* isProd */.BB)() ? " search__performance-select-alloys" : ""),
                    title: "Alloys",
                    name: "alloys",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "",
                            label: "Any"
                        }),
                        availableAlloys.length > 0 && availableAlloys.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                value: item.id,
                                children: [
                                    "Minimum ",
                                    item.name,
                                    " inch"
                                ]
                            }, item.id);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Alloys_Icon, {
                    customClass: (search_module_default()).icon,
                    name: "ChevronDown",
                    size: system/* Size.Medium */.$u.Medium
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "Alloys" options available based on your current filter selections'
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/Alloys/index.ts


// EXTERNAL MODULE: ./components/search/inputs/Checkbox/index.ts
var Checkbox = __webpack_require__(20237);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
;// CONCATENATED MODULE: ./components/search/filters/AvailableMultiSelect/AvailableMultiSelect.tsx









var AvailableMultiSelect = function(param) {
    var filter = param.filter, toggleFilter = param.toggleFilter, onChange = param.onChange, isFilterOpen = param.isFilterOpen, title = param.title, _hasAbbreviatedLabels = param.hasAbbreviatedLabels, hasAbbreviatedLabels = _hasAbbreviatedLabels === void 0 ? false : _hasAbbreviatedLabels;
    var current = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchParametersFilterByParameter */.GA)(state, filter);
    });
    var availableOptions = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableFilters */.BZ)[filter];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        maximumNumberOfVisibleSelectedOptions: 3,
        hasSelectedOptions: current.length > 0,
        selectedOptions: current.length > 0 ? (0,_to_consumable_array/* default */.Z)(current).sort(function(a, b) {
            return a - b;
        }).map(function(i) {
            return (0,search/* filterLabelPrettyName */.p$)(filter, i, undefined, hasAbbreviatedLabels);
        }) : [
            "All"
        ],
        children: availableOptions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (search_module_default())["multi-select"],
            children: availableOptions.map(function(i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                    filter: filter,
                    isSelected: current.includes(i.id),
                    valueAttribute: "id",
                    onChange: onChange,
                    item: i,
                    className: !(0,utilities_system/* isProd */.BB)() ? "search__".concat(filter, "-button search__").concat(filter, "-button-").concat((0,search/* filterClassName */.h1)((0,search/* filterLabelPrettyName */.p$)(filter, i.name))) : ""
                }, i.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "'.concat(title, '" options available based on your current filter selections')
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/AvailableMultiSelect/index.ts


;// CONCATENATED MODULE: ./components/search/filters/AvailableVehiclePriceTagsMultiSelect/AvailableVehiclePriceTagsMultiSelect.tsx













var AvailableVehiclePriceTagsMultiSelect = function(param) {
    var toggleFilter = param.toggleFilter, onChange = param.onChange, isFilterOpen = param.isFilterOpen, title = param.title, filter = param.filter;
    var activeDeliveryTimeTags = (0,es/* useSelector */.v9)(selectors_search/* selectActiveDeliveryTimeVehiclePriceTags */.R_);
    var activeInclusiveBenefits = (0,es/* useSelector */.v9)(selectors_search/* selectActiveInclusiveBenefitsVehiclePriceTags */.$x);
    var availableDeliveryTimeTags = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableLeadTimes */.d5);
    var availableInclusiveBenefitsTags = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableVehiclePriceTagsWithoutLeadTimes */.Kq);
    var ref = (0,react.useState)([]), selectedOptions = ref[0], setSelectedOptions = ref[1];
    (0,react.useEffect)(function() {
        setSelectedOptions(filter === constants/* FILTER_DELIVERY */.qU ? activeDeliveryTimeTags : activeInclusiveBenefits);
    }, [
        activeInclusiveBenefits,
        activeDeliveryTimeTags,
        filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        maximumNumberOfVisibleSelectedOptions: 3,
        hasSelectedOptions: (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0,
        selectedOptions: (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 ? filter === constants/* FILTER_DELIVERY */.qU ? (0,_to_consumable_array/* default */.Z)(selectedOptions[0].vehiclePriceTagIds).sort(function(a, b) {
            return a - b;
        }).map(function(selected) {
            var ref, ref1;
            return (0,search/* filterLabelPrettyName */.p$)(constants/* FILTER_DELIVERY */.qU, ((ref = availableDeliveryTimeTags.filter(function(available) {
                return available.id === selected;
            })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.filterLabel) || null, undefined, true);
        }) : selectedOptions.map(function(selected) {
            var ref;
            return (ref = availableInclusiveBenefitsTags.filter(function(available) {
                return available.id === selected.vehiclePriceTagCategoryId;
            })[0]) === null || ref === void 0 ? void 0 : ref.name;
        }) : [
            "All"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_module_default())["multi-select"],
            children: [
                filter === constants/* FILTER_INCLUSIVE_BENEFITS */.s9 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: availableInclusiveBenefitsTags.length > 0 ? availableInclusiveBenefitsTags.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                            item: option,
                            isSelected: selectedOptions.findIndex(function(active) {
                                return active.vehiclePriceTagCategoryId === option.id;
                            }) > -1,
                            valueAttribute: "id",
                            onChange: function(params) {
                                return onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                    filter: filter,
                                    isGrouped: true,
                                    vehiclePriceTag: {
                                        category: option.id
                                    }
                                }));
                            },
                            filter: filter,
                            type: "vehiclePriceTag",
                            className: !(0,utilities_system/* isProd */.BB)() ? "search__".concat(filter, "-button search__").concat(filter, "-button-").concat((0,search/* filterClassName */.h1)((0,search/* filterLabelPrettyName */.p$)(filter, option.name))) : ""
                        }, option.id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (search_module_default())["error-text"],
                        children: 'There are no "'.concat(title, '" options available based on your current filter selections')
                    })
                }),
                filter === constants/* FILTER_DELIVERY */.qU && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: availableDeliveryTimeTags.length > 0 ? availableDeliveryTimeTags.map(function(option) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                            item: {
                                id: option.id,
                                name: option.filterLabel
                            },
                            isSelected: (ref = activeDeliveryTimeTags[0]) === null || ref === void 0 ? void 0 : ref.vehiclePriceTagIds.includes(option.id),
                            valueAttribute: "id",
                            onChange: function(params) {
                                return onChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                    filter: filter,
                                    isGrouped: false,
                                    vehiclePriceTag: {
                                        category: 3,
                                        tag: option.id
                                    }
                                }));
                            },
                            resultCount: option.filterStatus === "UNAVAILABLE" ? 0 : undefined,
                            showResultCount: false,
                            filter: filter,
                            type: "vehiclePriceTag",
                            className: !(0,utilities_system/* isProd */.BB)() ? "search__".concat(filter, "-button search__").concat(filter, "-button-").concat((0,search/* filterClassName */.h1)(option.filterLabel)) : ""
                        }, option.id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (search_module_default())["error-text"],
                        children: 'There are no "'.concat(title, '" options available based on your current filter selections')
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/AvailableVehiclePriceTagsMultiSelect/index.ts


// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/react-range/lib/index.js
var lib = __webpack_require__(94398);
// EXTERNAL MODULE: ./components/search/inputs/Range/range.module.scss
var range_module = __webpack_require__(69113);
var range_module_default = /*#__PURE__*/__webpack_require__.n(range_module);
;// CONCATENATED MODULE: ./components/search/inputs/Range/Range.tsx









var Range = function(param) {
    var filter = param.filter, filteredTypeName = param.filteredTypeName, _step = param.step, step = _step === void 0 ? 25 : _step, _availableMinimum = param.availableMinimum, availableMinimum = _availableMinimum === void 0 ? 0 : _availableMinimum, _availableMaximum = param.availableMaximum, availableMaximum = _availableMaximum === void 0 ? 100 : _availableMaximum, _activeMinimum = param.activeMinimum, activeMinimum = _activeMinimum === void 0 ? 0 : _activeMinimum, _activeMaximum = param.activeMaximum, activeMaximum = _activeMaximum === void 0 ? 100 : _activeMaximum, onChange = param.onChange, onFinalChange = param.onFinalChange, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _showValues = param.showValues, showValues = _showValues === void 0 ? true : _showValues;
    var onRangeChange = function(changedValues) {
        if (onChange) {
            onChange(changedValues);
        }
    };
    var onFinalRangeChange = function(changedValues) {
        if (onFinalChange) {
            onFinalChange(changedValues);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((range_module_default()).range, " ").concat(filter === constants/* FILTER_MONTHLY_PAYMENT */.cF || filter === constants/* FILTER_INITIAL_PAYMENT */.Cl ? (range_module_default())["has-margin"] : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Range, {
                disabled: isLoading,
                values: [
                    activeMinimum,
                    activeMaximum
                ],
                step: step,
                min: availableMinimum,
                max: availableMaximum,
                onFinalChange: function(values) {
                    return onFinalRangeChange(values);
                },
                onChange: function(values) {
                    return onRangeChange(values);
                },
                renderTrack: function(param) {
                    var props = param.props, children = param.children;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onMouseDown: props.onMouseDown,
                        onTouchStart: props.onTouchStart,
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.style), {
                            height: "2rem",
                            display: "flex",
                            width: "100%",
                            padding: "0 1rem"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: props.ref,
                            style: {
                                height: "0.125rem",
                                width: "100%",
                                borderRadius: "0.25rem",
                                background: (0,lib.getTrackBackground)({
                                    values: [
                                        activeMinimum,
                                        activeMaximum
                                    ],
                                    colors: [
                                        "#7878801F",
                                        "#FF2D55",
                                        "#7878801F"
                                    ],
                                    min: availableMinimum,
                                    max: availableMaximum
                                }),
                                alignSelf: "center"
                            },
                            children: children
                        })
                    });
                },
                renderThumb: function(param) {
                    var props = param.props, index = param.index;
                    /*#__PURE__*/ return (0,react.createElement)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        key: props.key,
                        className: !(0,utilities_system/* isProd */.BB)() ? "search__".concat(filteredTypeName === null || filteredTypeName === void 0 ? void 0 : filteredTypeName.toLowerCase(), "-range-").concat(index === 0 ? "min" : "max") : "",
                        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.style), {
                            height: "2rem",
                            width: "2rem",
                            borderRadius: "100%",
                            backgroundColor: "#FFF",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "0.0625rem solid #7A7A7A29",
                            filter: "drop-shadow(0 0.125rem 0.5rem rgba(0, 0, 0, 0.05))"
                        })
                    }));
                }
            }),
            showValues && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (range_module_default()).values,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,search/* filterLabelPrettyName */.p$)(filter, activeMinimum, filteredTypeName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,search/* filterLabelPrettyName */.p$)(filter, activeMaximum, filteredTypeName)
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/Range/index.ts


// EXTERNAL MODULE: ./components/search/filters/Capacity/capacity.module.scss
var capacity_module = __webpack_require__(55123);
var capacity_module_default = /*#__PURE__*/__webpack_require__.n(capacity_module);
// EXTERNAL MODULE: ./components/atomic/ComponentErrorBoundary/index.js + 1 modules
var ComponentErrorBoundary = __webpack_require__(84890);
// EXTERNAL MODULE: ./lib/loaders.js
var loaders = __webpack_require__(27386);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var reducers_search = __webpack_require__(29109);
// EXTERNAL MODULE: ./store/selectors/loader.js
var loader = __webpack_require__(56428);
;// CONCATENATED MODULE: ./components/search/filters/Capacity/Capacity.tsx
















var Capacity = function(param) {
    var _isFilterOpen = param.isFilterOpen, isFilterOpen = _isFilterOpen === void 0 ? false : _isFilterOpen, title = param.title, toggleFilter = param.toggleFilter;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var availableCapacityFilters = (0,es/* useSelector */.v9)(selectors_search/* selectCapacitySearchFilter */.ou);
    var activeCapacityFilters = (0,es/* useSelector */.v9)(selectors_search/* selectActiveCapacity */.H_);
    var isLoading = (0,es/* useSelector */.v9)(function(state) {
        return (0,loader/* selectLoaderExists */.u)(state, loaders/* LOADERS.fetchingSearchFilter.capacity */.Y.fetchingSearchFilter.capacity);
    });
    var ref8 = (0,react.useState)(((ref = activeCapacityFilters.payload) === null || ref === void 0 ? void 0 : ref.min) || availableCapacityFilters.payload.min), minPayloadVal = ref8[0], setMinPayloadVal = ref8[1];
    var ref9 = (0,react.useState)(((ref1 = activeCapacityFilters.payload) === null || ref1 === void 0 ? void 0 : ref1.max) || availableCapacityFilters.payload.max), maxPayloadVal = ref9[0], setMaxPayloadVal = ref9[1];
    var ref10 = (0,react.useState)(((ref2 = activeCapacityFilters.loadLength) === null || ref2 === void 0 ? void 0 : ref2.min) || availableCapacityFilters.loadLength.min), minLengthVal = ref10[0], setMinLengthVal = ref10[1];
    var ref11 = (0,react.useState)(((ref3 = activeCapacityFilters.loadLength) === null || ref3 === void 0 ? void 0 : ref3.max) || availableCapacityFilters.loadLength.max), maxLengthVal = ref11[0], setMaxLengthVal = ref11[1];
    var ref12 = (0,react.useState)(((ref4 = activeCapacityFilters.loadHeight) === null || ref4 === void 0 ? void 0 : ref4.min) || availableCapacityFilters.loadHeight.min), minHeightVal = ref12[0], setMinHeightVal = ref12[1];
    var ref13 = (0,react.useState)(((ref5 = activeCapacityFilters.loadHeight) === null || ref5 === void 0 ? void 0 : ref5.max) || availableCapacityFilters.loadHeight.max), maxHeightVal = ref13[0], setMaxHeightVal = ref13[1];
    var ref14 = (0,react.useState)(((ref6 = activeCapacityFilters.loadWidth) === null || ref6 === void 0 ? void 0 : ref6.min) || availableCapacityFilters.loadWidth.min), minWidthVal = ref14[0], setMinWidthVal = ref14[1];
    var ref15 = (0,react.useState)(((ref7 = activeCapacityFilters.loadWidth) === null || ref7 === void 0 ? void 0 : ref7.max) || availableCapacityFilters.loadWidth.max), maxWidthVal = ref15[0], setMaxWidthVal = ref15[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        setMinPayloadVal(((ref = activeCapacityFilters.payload) === null || ref === void 0 ? void 0 : ref.min) || availableCapacityFilters.payload.min);
        setMaxPayloadVal(((ref1 = activeCapacityFilters.payload) === null || ref1 === void 0 ? void 0 : ref1.max) || availableCapacityFilters.payload.max);
        setMinLengthVal(((ref2 = activeCapacityFilters.loadLength) === null || ref2 === void 0 ? void 0 : ref2.min) || availableCapacityFilters.loadLength.min);
        setMaxLengthVal(((ref3 = activeCapacityFilters.loadLength) === null || ref3 === void 0 ? void 0 : ref3.max) || availableCapacityFilters.loadLength.max);
        setMinHeightVal(((ref4 = activeCapacityFilters.loadHeight) === null || ref4 === void 0 ? void 0 : ref4.min) || availableCapacityFilters.loadHeight.min);
        setMaxHeightVal(((ref5 = activeCapacityFilters.loadHeight) === null || ref5 === void 0 ? void 0 : ref5.max) || availableCapacityFilters.loadHeight.max);
        setMinWidthVal(((ref6 = activeCapacityFilters.loadWidth) === null || ref6 === void 0 ? void 0 : ref6.min) || availableCapacityFilters.loadWidth.min);
        setMaxWidthVal(((ref7 = activeCapacityFilters.loadWidth) === null || ref7 === void 0 ? void 0 : ref7.max) || availableCapacityFilters.loadWidth.max);
    }, [
        activeCapacityFilters,
        availableCapacityFilters
    ]);
    var onCapacityFinalChange = function(filter, values) {
        dispatch((0,reducers_search/* storeSearchParameters */.rq)({
            filter: "".concat(filter, "Min"),
            value: Number(values[0])
        }));
        dispatch((0,reducers_search/* storeSearchParameters */.rq)({
            filter: "".concat(filter, "Max"),
            value: Number(values[1])
        }));
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "search-filter",
            "filter-event": "add-filter",
            "filter-category": "capacity",
            "filter-label": filter,
            "filter-value": "".concat(values[0], " ").concat(values[1])
        });
        if (router.asPath.includes("page=")) {
            router.push("/van-leasing/search", undefined, {
                scroll: false
            });
        }
        modules/* animateScroll.scrollToTop */.NY.scrollToTop({
            duration: 1000,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    var onCapacityChange = function(filter, values) {
        if (filter === constants/* FILTER_CAPACITY_PAYLOAD */.$P) {
            setMinPayloadVal(values[0]);
            setMaxPayloadVal(values[1]);
        }
        if (filter === constants/* FILTER_CAPACITY_LOAD_LENGTH */._C) {
            setMinLengthVal(values[0]);
            setMaxLengthVal(values[1]);
        }
        if (filter === constants/* FILTER_CAPACITY_LOAD_HEIGHT */.hZ) {
            setMinHeightVal(values[0]);
            setMaxHeightVal(values[1]);
        }
        if (filter === constants/* FILTER_CAPACITY_LOAD_WIDTH */.Jq) {
            setMinWidthVal(values[0]);
            setMaxWidthVal(values[1]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: Object.keys(activeCapacityFilters).length > 0,
        selectedOptions: Object.keys(activeCapacityFilters).length > 0 ? Object.keys(activeCapacityFilters).map(function(filter) {
            return "".concat((0,search/* capitaliseFirstLetter */.zd)(filter === constants/* FILTER_CAPACITY_PAYLOAD */.$P ? filter : filter.replace("load", "")), ": ").concat((0,search/* filterLabelPrettyName */.p$)(constants/* FILTER_CAPACITY */.gI, activeCapacityFilters[filter].min || availableCapacityFilters[filter].min, filter), "-").concat((0,search/* filterLabelPrettyName */.p$)(constants/* FILTER_CAPACITY */.gI, activeCapacityFilters[filter].max || availableCapacityFilters[filter].max, filter));
        }) : [
            "All"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (capacity_module_default()).sliders,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (capacity_module_default()).row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (capacity_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Payload"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                                filter: constants/* FILTER_CAPACITY */.gI,
                                filteredTypeName: constants/* FILTER_CAPACITY_PAYLOAD */.$P,
                                availableMinimum: availableCapacityFilters.payload.min >= maxPayloadVal ? minPayloadVal : availableCapacityFilters.payload.min,
                                availableMaximum: availableCapacityFilters.payload.max >= constants/* FILTER_CAPACITY_PAYLOAD_MAX */.Sb ? constants/* FILTER_CAPACITY_PAYLOAD_MAX */.Sb : availableCapacityFilters.payload.max,
                                activeMinimum: minPayloadVal,
                                activeMaximum: maxPayloadVal,
                                step: 100,
                                onChange: function(values) {
                                    return onCapacityChange(constants/* FILTER_CAPACITY_PAYLOAD */.$P, values);
                                },
                                onFinalChange: function(values) {
                                    return onCapacityFinalChange(constants/* FILTER_CAPACITY_PAYLOAD */.$P, values);
                                },
                                isLoading: isLoading
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (capacity_module_default()).row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (capacity_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Load Length"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                                filter: constants/* FILTER_CAPACITY */.gI,
                                filteredTypeName: constants/* FILTER_CAPACITY_LOAD_LENGTH */._C,
                                availableMinimum: availableCapacityFilters.loadLength.min >= maxLengthVal ? minLengthVal : availableCapacityFilters.loadLength.min,
                                availableMaximum: availableCapacityFilters.loadLength.max >= constants/* FILTER_CAPACITY_LOAD_LENGTH_MAX */.bm ? constants/* FILTER_CAPACITY_LOAD_LENGTH_MAX */.bm : availableCapacityFilters.loadLength.max,
                                activeMinimum: minLengthVal,
                                activeMaximum: maxLengthVal,
                                onChange: function(values) {
                                    return onCapacityChange(constants/* FILTER_CAPACITY_LOAD_LENGTH */._C, values);
                                },
                                onFinalChange: function(values) {
                                    return onCapacityFinalChange(constants/* FILTER_CAPACITY_LOAD_LENGTH */._C, values);
                                },
                                isLoading: isLoading
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (capacity_module_default()).row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (capacity_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Load Height"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                                filter: constants/* FILTER_CAPACITY */.gI,
                                filteredTypeName: constants/* FILTER_CAPACITY_LOAD_HEIGHT */.hZ,
                                availableMinimum: availableCapacityFilters.loadHeight.min >= maxHeightVal ? minHeightVal : availableCapacityFilters.loadHeight.min,
                                availableMaximum: availableCapacityFilters.loadHeight.max >= constants/* FILTER_CAPACITY_LOAD_HEIGHT_MAX */.dG ? constants/* FILTER_CAPACITY_LOAD_HEIGHT_MAX */.dG : availableCapacityFilters.loadHeight.max,
                                activeMinimum: minHeightVal,
                                activeMaximum: maxHeightVal,
                                onChange: function(values) {
                                    return onCapacityChange(constants/* FILTER_CAPACITY_LOAD_HEIGHT */.hZ, values);
                                },
                                onFinalChange: function(values) {
                                    return onCapacityFinalChange(constants/* FILTER_CAPACITY_LOAD_HEIGHT */.hZ, values);
                                },
                                isLoading: isLoading
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (capacity_module_default()).row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (capacity_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Load Width"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                                filter: constants/* FILTER_CAPACITY */.gI,
                                filteredTypeName: constants/* FILTER_CAPACITY_LOAD_WIDTH */.Jq,
                                availableMinimum: availableCapacityFilters.loadWidth.min >= maxWidthVal ? minWidthVal : availableCapacityFilters.loadWidth.min,
                                availableMaximum: availableCapacityFilters.loadWidth.max >= constants/* FILTER_CAPACITY_LOAD_WIDTH_MAX */.k0 ? constants/* FILTER_CAPACITY_LOAD_WIDTH_MAX */.k0 : availableCapacityFilters.loadWidth.max,
                                activeMinimum: minWidthVal,
                                activeMaximum: maxWidthVal,
                                onChange: function(values) {
                                    return onCapacityChange(constants/* FILTER_CAPACITY_LOAD_WIDTH */.Jq, values);
                                },
                                onFinalChange: function(values) {
                                    return onCapacityFinalChange(constants/* FILTER_CAPACITY_LOAD_WIDTH */.Jq, values);
                                },
                                isLoading: isLoading
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/Capacity/index.ts


// EXTERNAL MODULE: ./components/search/inputs/Checkbox/Checkbox.tsx
var Checkbox_Checkbox = __webpack_require__(24542);
// EXTERNAL MODULE: ./components/search/filters/ComfortAndSafety/comfort-and-safety.module.scss
var comfort_and_safety_module = __webpack_require__(62599);
var comfort_and_safety_module_default = /*#__PURE__*/__webpack_require__.n(comfort_and_safety_module);
;// CONCATENATED MODULE: ./components/search/filters/ComfortAndSafety/ComfortAndSafety.tsx













var ComfortAndSafety_Icon = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var ComfortAndSafety = function(param) {
    var isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange;
    var availableSpec = (0,es/* useSelector */.v9)(selectors_search/* selectSpecSearchFilter */.bn);
    var selectedSpec = (0,es/* useSelector */.v9)(selectors_search/* selectFullActiveSpec */.j4);
    var ref = (0,react.useState)([]), availableFilters = ref[0], setAvailableFilters = ref[1];
    var ref1 = (0,react.useState)([]), selectedFilters = ref1[0], setSelectedFilters = ref1[1];
    (0,react.useEffect)(function() {
        setAvailableFilters(availableSpec.filter(function(spec) {
            return spec.categoryId === 3;
        }));
    }, [
        availableSpec
    ]);
    (0,react.useEffect)(function() {
        setSelectedFilters(selectedSpec.filter(function(spec) {
            return spec.category === 3 || spec.filter === "Heated Seats" || spec.filter === "Leather Seats";
        }));
    }, [
        selectedSpec
    ]);
    var onChangeSelect = function(param) {
        var event = param.event, name = param.name;
        if (event.currentTarget.value === "-1") {
            var selectedId = selectedSpec.filter(function(spec) {
                return spec.filter === name;
            })[0];
            onChange({
                type: "multi",
                value: selectedId.id,
                filter: constants/* FILTER_SPEC */.q9
            });
        } else {
            onChange({
                type: "multi",
                value: parseInt(event.currentTarget.value),
                filter: constants/* FILTER_SPEC */.q9
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Comfort & safety",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: selectedFilters.length > 0,
        maximumNumberOfVisibleSelectedOptions: 2,
        selectedOptions: selectedFilters.length > 0 ? selectedFilters.map(function(filter) {
            return filter.name;
        }) : [
            "All"
        ],
        children: availableFilters.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (search_module_default())["multi-select"],
            children: availableFilters.sort(function(a, b) {
                return !!a.subFilters - !!b.subFilters;
            }).map(function(available) {
                if (available.subFilters) {
                    var ref, ref1;
                    var ref2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (search_module_default())["sub-filter-header"],
                                children: available.name
                            }),
                            available.name === "Heated Seats" ? available.subFilters.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox/* Checkbox */.X, {
                                    filter: constants/* FILTER_SPEC */.q9,
                                    onChange: onChange,
                                    item: item,
                                    valueAttribute: "id",
                                    isSelected: selectedFilters.filter(function(filter) {
                                        return filter.id === item.id;
                                    }).length > 0,
                                    className: !(0,utilities_system/* isProd */.BB)() ? "search__comfort-button search__comfort-button-".concat((0,search/* filterClassName */.h1)(item.name)) : ""
                                }, item.id);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((search_module_default()).select, " ").concat((comfort_and_safety_module_default())["no-margin"]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        onChange: function(event) {
                                            return onChangeSelect({
                                                event: event,
                                                name: available.name
                                            });
                                        },
                                        defaultValue: -1,
                                        value: (ref2 = (ref = available.subFilters.filter(function(i) {
                                            return !!selectedFilters.find(function(j) {
                                                return j.id === i.id;
                                            });
                                        })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : -1,
                                        className: "".concat((search_module_default()).control).concat(!(0,utilities_system/* isProd */.BB)() ? " search__comfort-select-".concat((0,search/* filterClassName */.h1)(available.name)) : ""),
                                        name: available.name,
                                        title: available.name,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: -1,
                                                label: "Any"
                                            }),
                                            available.subFilters.map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: item.id,
                                                    children: item.name
                                                }, item.id);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComfortAndSafety_Icon, {
                                        customClass: (search_module_default()).icon,
                                        name: "ChevronDown",
                                        size: system/* Size.Medium */.$u.Medium
                                    })
                                ]
                            })
                        ]
                    }, available.id);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox/* Checkbox */.X, {
                    valueAttribute: "id",
                    item: available,
                    isSelected: selectedFilters.filter(function(filter) {
                        return filter.id === available.id;
                    }).length > 0,
                    filter: constants/* FILTER_SPEC */.q9,
                    onChange: onChange,
                    className: !(0,utilities_system/* isProd */.BB)() ? "search__comfort-button search__comfort-button-".concat((0,search/* filterClassName */.h1)(available.name)) : ""
                }, available.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "Comfort & safety" options available based on your current filter selections'
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/ComfortAndSafety/index.ts


;// CONCATENATED MODULE: ./components/search/filters/Convenience/Convenience.tsx











var Convenience_Icon = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Convenience = function(param) {
    var isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange;
    var availableSpec = (0,es/* useSelector */.v9)(selectors_search/* selectSpecSearchFilter */.bn);
    var selectedSpec = (0,es/* useSelector */.v9)(selectors_search/* selectFullActiveSpec */.j4);
    var ref = (0,react.useState)([]), availableFilters = ref[0], setAvailableFilters = ref[1];
    var ref1 = (0,react.useState)([]), selectedFilters = ref1[0], setSelectedFilters = ref1[1];
    (0,react.useEffect)(function() {
        setAvailableFilters(availableSpec.filter(function(spec) {
            return spec.categoryId === 1;
        }));
    }, [
        availableSpec
    ]);
    (0,react.useEffect)(function() {
        setSelectedFilters(selectedSpec.filter(function(spec) {
            return spec.category === 1 || spec.filter === "Parking Sensors";
        }));
    }, [
        selectedSpec
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Convenience",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: selectedFilters.length > 0,
        maximumNumberOfVisibleSelectedOptions: 2,
        selectedOptions: selectedFilters.length > 0 ? selectedFilters.map(function(filter) {
            return filter.name;
        }) : [
            "All"
        ],
        children: availableFilters.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (search_module_default())["multi-select"],
            children: availableFilters.sort(function(a, b) {
                return !!a.subFilters - !!b.subFilters;
            }).map(function(available) {
                if (available.subFilters) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (search_module_default())["sub-filter-header"],
                                children: available.name
                            }),
                            available.subFilters.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox/* Checkbox */.X, {
                                    filter: constants/* FILTER_SPEC */.q9,
                                    onChange: onChange,
                                    item: item,
                                    valueAttribute: "id",
                                    isSelected: selectedFilters.filter(function(filter) {
                                        return filter.id === item.id;
                                    }).length > 0,
                                    className: !(0,utilities_system/* isProd */.BB)() ? "search__convenience-button search__convenience-button-".concat((0,search/* filterClassName */.h1)(item.name)) : ""
                                }, item.id);
                            })
                        ]
                    }, available.id);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox/* Checkbox */.X, {
                    valueAttribute: "id",
                    item: available,
                    isSelected: selectedFilters.filter(function(filter) {
                        return filter.id === available.id;
                    }).length > 0,
                    filter: constants/* FILTER_SPEC */.q9,
                    onChange: onChange,
                    className: !(0,utilities_system/* isProd */.BB)() ? "search__convenience-button search__convenience-button-".concat((0,search/* filterClassName */.h1)(available.name)) : ""
                }, available.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "Convenience" options available based on your current filter selections'
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/Convenience/index.ts


;// CONCATENATED MODULE: ./components/search/inputs/ElectricMinMaxSelect/ElectricMinMaxSelect.tsx




var ElectricMinMaxSelect = function(param) {
    var activeMin = param.activeMin, activeMax = param.activeMax, availableMaximum = param.availableMaximum, availableMinimum = param.availableMinimum, handleMinInput = param.handleMinInput, handleMaxInput = param.handleMaxInput, title = param.title, filter = param.filter;
    var hasOptions = !!(availableMinimum.length > 0 && availableMaximum.length > 0 || activeMin || activeMax);
    if (!hasOptions) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "'.concat(title, '" options available based on your current filter selections.')
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).minmax,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_module_default()).selects,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).label,
                        children: "Min"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default()).select,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                className: (search_module_default()).control,
                                id: "".concat(filter, "-min"),
                                title: "".concat(title, " minimum"),
                                onChange: function(e) {
                                    return handleMinInput(e.target.value ? parseInt(e.target.value, 10) : undefined);
                                },
                                value: activeMin || "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "",
                                        children: "Any"
                                    }),
                                    availableMinimum.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: item,
                                            children: [
                                                item,
                                                "kWh"
                                            ]
                                        }, item);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon["default"], {
                                customClass: (search_module_default()).icon,
                                name: "ChevronDown",
                                size: system/* Size.Medium */.$u.Medium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_module_default()).selects,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).label,
                        children: "Max"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default()).select,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                className: (search_module_default()).control,
                                id: "".concat(filter, "-max"),
                                title: "".concat(title, " maximum"),
                                onChange: function(e) {
                                    return handleMaxInput(e.target.value ? parseInt(e.target.value, 10) : undefined);
                                },
                                value: activeMax || "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "",
                                        children: "Any"
                                    }),
                                    availableMaximum.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: item,
                                            children: [
                                                item,
                                                "kWh"
                                            ]
                                        }, item);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon["default"], {
                                customClass: (search_module_default()).icon,
                                name: "ChevronDown",
                                size: system/* Size.Medium */.$u.Medium
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/ElectricMinMaxSelect/index.ts


;// CONCATENATED MODULE: ./components/search/filters/ElectricFilterMinMax/ElectricFilterMinMax.tsx







var ElectricFilterMinMax = function(param) {
    var isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange, filter = param.filter, title = param.title;
    var availableFilter = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchSliceByParameter */.MI)(state, filter);
    });
    var activeFilter = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchParametersFilterByParameter */.GA)(state, filter);
    });
    var ref = (0,react.useState)(undefined), activeFilterMin = ref[0], setActiveFilterMin = ref[1];
    var ref1 = (0,react.useState)(undefined), activeFilterMax = ref1[0], setActiveFilterMax = ref1[1];
    var ref2 = (0,react.useState)([]), availableFilterMin = ref2[0], setAvailableFilterMin = ref2[1];
    var ref3 = (0,react.useState)([]), availableFilterMax = ref3[0], setAvailableFilterMax = ref3[1];
    var ref4 = (0,react.useState)(undefined), minVal = ref4[0], setMinVal = ref4[1];
    var ref5 = (0,react.useState)(undefined), maxVal = ref5[0], setMaxVal = ref5[1];
    (0,react.useEffect)(function() {
        if (activeFilter) {
            var activeMin = activeFilter.length > 0 && activeFilter[0].length > 0 ? activeFilter[0].split("-")[0] : undefined;
            var activeMax = activeFilter.length > 0 && activeFilter[0].length > 0 ? activeFilter[0].split("-")[1] : undefined;
            setActiveFilterMin(activeMin ? Number(activeMin) : undefined);
            setMinVal(activeMin);
            setActiveFilterMax(activeMax ? Number(activeMax) : undefined);
            setMaxVal(activeMax);
        }
    }, [
        activeFilter,
        availableFilterMax,
        availableFilterMin
    ]);
    (0,react.useEffect)(function() {
        if (availableFilter) {
            setAvailableFilterMin(availableFilter === null || availableFilter === void 0 ? void 0 : availableFilter.availableValueRangeFilterList.map(function(i) {
                return parseInt(i.range.split("-")[0]);
            }).filter(function(i) {
                return i < availableFilter.filterMinMaxRange.max && (activeFilterMin ? i !== activeFilterMin : true);
            }).filter(function(i) {
                return (!activeFilterMax && activeFilterMax !== 0 || (activeFilterMax ? i < activeFilterMax : true)) && i !== activeFilterMin;
            }).concat(activeFilterMin || activeFilterMin === 0 ? activeFilterMin : []).sort(function(a, b) {
                return a - b;
            }));
            setAvailableFilterMax(availableFilter === null || availableFilter === void 0 ? void 0 : availableFilter.availableValueRangeFilterList.map(function(i) {
                return parseInt(i.range.split("-")[1]);
            }).filter(function(i) {
                return i > availableFilter.filterMinMaxRange.min;
            }).filter(function(i) {
                return (!activeFilterMin && activeFilterMin !== 0 || (activeFilterMin ? i > activeFilterMin : true)) && i !== activeFilterMax;
            }).concat(activeFilterMax ? activeFilterMax : []).sort(function(a, b) {
                return a - b;
            }));
        }
    }, [
        availableFilter
    ]);
    var handleMinInput = function(value) {
        var newValue = value || value === 0 ? value : undefined;
        setMinVal(newValue);
        if (activeFilterMin) {
            onChangeInputValue(activeFilterMin, "min");
        }
        onChangeInputValue(newValue, "min");
    };
    var handleMaxInput = function(value) {
        var newValue = value ? value : undefined;
        setMaxVal(newValue);
        if (activeFilterMax) {
            onChangeInputValue(activeFilterMax, "max");
        }
        onChangeInputValue(newValue, "max");
    };
    var onChangeInputValue = function(newValue, minOrMax) {
        var value = minOrMax === "min" ? "".concat(newValue || newValue === 0 ? newValue : "", "-").concat(maxVal || "") : "".concat(minVal || "", "-").concat(newValue ? newValue : "");
        onChange({
            type: "single",
            filter: filter,
            value: value ? value !== "-" ? [
                value
            ] : [] : []
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: !!minVal || minVal === 0 || !!maxVal,
        selectedOptions: minVal || minVal === 0 || maxVal ? [
            "".concat((0,search/* getElectricFilterLabelPrettyName */.XO)(filter, "".concat(minVal, "-").concat(maxVal), undefined, true, "first")), 
        ] : [
            "All"
        ],
        maximumNumberOfVisibleSelectedOptions: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectricMinMaxSelect, {
                title: title,
                filter: filter,
                activeMin: minVal,
                activeMax: maxVal,
                handleMinInput: handleMinInput,
                handleMaxInput: handleMaxInput,
                availableMaximum: availableFilterMax,
                availableMinimum: availableFilterMin
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/ElectricFilterMinMax/index.ts


;// CONCATENATED MODULE: ./components/search/inputs/MinMaxSelect/MinMaxSelect.tsx




var MinMaxSelect = function(param) {
    var activeMin = param.activeMin, activeMax = param.activeMax, availableMaximum = param.availableMaximum, availableMinimum = param.availableMinimum, handleMinInput = param.handleMinInput, handleMaxInput = param.handleMaxInput;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).minmax,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_module_default()).selects,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).label,
                        children: "Min"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default()).select,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                className: (search_module_default()).control,
                                id: "engine-min",
                                title: "Engine size minimum",
                                onChange: function(e) {
                                    return handleMinInput(parseInt(e.target.value, 10));
                                },
                                value: activeMin || "-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "-1",
                                        children: "Any"
                                    }),
                                    availableMinimum.filter(function(item) {
                                        return item.type === 20 && (activeMax ? item.id < activeMax - 9 : item.id <= 53);
                                    }).map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: item.id,
                                            children: [
                                                item.name,
                                                "L"
                                            ]
                                        }, item.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon["default"], {
                                customClass: (search_module_default()).icon,
                                name: "ChevronDown",
                                size: system/* Size.Medium */.$u.Medium
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_module_default()).selects,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).label,
                        children: "Max"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default()).select,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                className: (search_module_default()).control,
                                id: "engine-max",
                                title: "Engine size maximum",
                                onChange: function(e) {
                                    return handleMaxInput(parseInt(e.target.value, 10));
                                },
                                value: activeMax || "-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: "-1",
                                        children: "Any"
                                    }),
                                    availableMaximum.filter(function(item) {
                                        return item.type === 21 && (activeMin ? item.id > activeMin + 9 : item.id > 53);
                                    }).map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                            value: item.id,
                                            children: [
                                                item.name,
                                                "L"
                                            ]
                                        }, item.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon["default"], {
                                customClass: (search_module_default()).icon,
                                name: "ChevronDown",
                                size: system/* Size.Medium */.$u.Medium
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/MinMaxSelect/index.ts


;// CONCATENATED MODULE: ./components/search/filters/EngineSize/EngineSize.tsx









var EngineSize = function(param) {
    var isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange;
    var ref, ref1, ref2, ref3, ref4;
    var availableEngine = (0,es/* useSelector */.v9)(selectors_search/* selectPerformanceSearchFilter */.Z4);
    var activePerformance = (0,es/* useSelector */.v9)(selectors_search/* selectFullActivePerformance */.vd);
    var ref5 = (0,react.useState)(undefined), activeEngineMin = ref5[0], setActiveEngineMin = ref5[1];
    var ref6 = (0,react.useState)(undefined), activeEngineMax = ref6[0], setActiveEngineMax = ref6[1];
    var ref7 = (0,react.useState)([]), availableEngineMin = ref7[0], setAvailableEngineMin = ref7[1];
    var ref8 = (0,react.useState)([]), availableEngineMax = ref8[0], setAvailableEngineMax = ref8[1];
    var ref9 = (0,react.useState)(undefined), minVal = ref9[0], setMinVal = ref9[1];
    var ref10 = (0,react.useState)(undefined), maxVal = ref10[0], setMaxVal = ref10[1];
    (0,react.useEffect)(function() {
        if (activePerformance) {
            var activeEngineMin = activePerformance.filter(function(eng) {
                return eng.type === 20;
            })[0];
            var activeEngineMax = activePerformance.filter(function(eng) {
                return eng.type === 21;
            })[0];
            setActiveEngineMin(activeEngineMin);
            setMinVal(activeEngineMin === null || activeEngineMin === void 0 ? void 0 : activeEngineMin.id);
            setActiveEngineMax(activeEngineMax);
            setMaxVal(activeEngineMax === null || activeEngineMax === void 0 ? void 0 : activeEngineMax.id);
        }
    }, [
        activePerformance
    ]);
    (0,react.useEffect)(function() {
        if (availableEngine) {
            setAvailableEngineMin(availableEngine.filter(function(eng) {
                return eng.type === 20;
            }));
            setAvailableEngineMax(availableEngine.filter(function(eng) {
                return eng.type === 21;
            }));
        }
    }, [
        availableEngine
    ]);
    var handleMinInput = function(value) {
        var newValue = value ? value : undefined;
        setMinVal(newValue);
        if (activeEngineMin) {
            onChangeInputValue(activeEngineMin.id);
        }
        onChangeInputValue(newValue);
    };
    var handleMaxInput = function(value) {
        var newValue = value ? value : undefined;
        setMaxVal(newValue);
        if (activeEngineMax) {
            onChangeInputValue(activeEngineMax.id);
        }
        onChangeInputValue(newValue);
    };
    var onChangeInputValue = function(newValue) {
        onChange({
            type: "multi",
            filter: constants/* FILTER_PERFORMANCE */.UF,
            value: newValue ? newValue : 0
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Engine size",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: !!minVal || !!maxVal,
        selectedOptions: minVal || maxVal ? [
            "".concat((0,search/* filterLabelPrettyName */.p$)(constants/* FILTER_PERFORMANCE */.UF, minVal ? (ref = availableEngineMin.filter(function(eng) {
                return eng.id === minVal;
            })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name : 0, "MIN_ENGINE"), "-").concat((0,search/* filterLabelPrettyName */.p$)(constants/* FILTER_PERFORMANCE */.UF, maxVal ? (ref2 = availableEngineMax.filter(function(eng) {
                return eng.id === maxVal;
            })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name : (ref4 = availableEngineMax.at(-1)) === null || ref4 === void 0 ? void 0 : ref4.name, "MAX_ENGINE")), 
        ] : [
            "All"
        ],
        maximumNumberOfVisibleSelectedOptions: 1,
        children: availableEngineMax.length > 0 || availableEngineMin.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (search_module_default()).Budget,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinMaxSelect, {
                activeMin: minVal,
                activeMax: maxVal,
                handleMinInput: handleMinInput,
                handleMaxInput: handleMaxInput,
                availableMaximum: availableEngineMax,
                availableMinimum: availableEngineMin
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "Engine Size" options available based on your current filter selections'
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/EngineSize/index.ts


;// CONCATENATED MODULE: ./components/search/filters/Features/Features.tsx








var Features = function(param) {
    var filter = param.filter, title = param.title, supportingText = param.supportingText, toggleFilter = param.toggleFilter, _isFilterOpen = param.isFilterOpen, isFilterOpen = _isFilterOpen === void 0 ? false : _isFilterOpen, onChange = param.onChange, typeName = param.typeName;
    var availableFeatures = (0,es/* useSelector */.v9)(selectors_search/* selectFeaturesSearchFilter */.i7);
    var selectedFeatures = (0,es/* useSelector */.v9)(selectors_search/* selectActiveFeatures */.xG);
    var selectedFullFeatures = (0,es/* useSelector */.v9)(selectors_search/* selectFullActiveFeatures */.r6);
    var featureCategories = {
        cab: 1,
        flatbed: 2,
        sidePanels: 3
    };
    var availableCategoryFeatures = availableFeatures.filter(function(feature) {
        return feature.categoryId === featureCategories[typeName];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: selectedFullFeatures.filter(function(feature) {
            return feature.categoryId === featureCategories[typeName];
        }).length > 0,
        selectedOptions: selectedFullFeatures.filter(function(feature) {
            return feature.categoryId === featureCategories[typeName];
        }).length > 0 ? selectedFullFeatures.filter(function(feature) {
            return feature.categoryId === featureCategories[typeName];
        }).map(function(i) {
            return (0,search/* filterLabelPrettyName */.p$)(filter, i.name);
        }) : [
            "All"
        ],
        children: availableCategoryFeatures.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (search_module_default())["multi-select"],
                    children: availableCategoryFeatures.map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                            valueAttribute: "id",
                            item: i,
                            isSelected: selectedFeatures.includes(i.id),
                            filter: filter,
                            onChange: onChange,
                            className: !(0,utilities_system/* isProd */.BB)() ? "search__".concat(filter, "-").concat((0,search/* filterClassName */.h1)(title), "-button search__").concat(filter, "-").concat((0,search/* filterClassName */.h1)(title), "-button-").concat((0,search/* filterClassName */.h1)(i.name)) : ""
                        }, i.id);
                    })
                }),
                supportingText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (search_module_default()).supporting,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (search_module_default()).title,
                            children: supportingText.title
                        }),
                        supportingText.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (search_module_default()).subtitle,
                            children: supportingText.subtitle
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "'.concat(title, '" options available based on your current filter selections')
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/Features/index.ts


;// CONCATENATED MODULE: ./components/search/inputs/MinMaxNumber/MinMaxNumber.tsx




var MinMaxNumber = function(param) {
    var activeMin = param.activeMin, activeMax = param.activeMax, availableMaximum = param.availableMaximum, availableMinimum = param.availableMinimum, minInput = param.minInput, maxInput = param.maxInput, _minGap = param.minGap, minGap = _minGap === void 0 ? 50 : _minGap, handleMinInput = param.handleMinInput, handleMaxInput = param.handleMaxInput, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).minmax,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                title: "Minimum",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).label,
                        children: "Min"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default())["input-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (search_module_default()).adornment,
                                children: "\xa3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "".concat((search_module_default()).input).concat(!(0,utilities_system/* isProd */.BB)() && label ? " search__".concat(label.toLowerCase(), "-input-min") : ""),
                                min: availableMinimum,
                                max: activeMax - minGap,
                                value: (0,search/* formatWithCommas */.b1)(minInput).toString().split(".")[0],
                                type: "text",
                                title: "Minimum",
                                onChange: function(e) {
                                    return handleMinInput(parseInt(e.target.value, 10));
                                },
                                inputMode: "numeric"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                title: "Maximum",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).label,
                        children: "Max"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_module_default())["input-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (search_module_default()).adornment,
                                children: "\xa3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "".concat((search_module_default()).input).concat(!(0,utilities_system/* isProd */.BB)() && label ? " search__".concat(label.toLowerCase(), "-input-max") : ""),
                                min: activeMin + minGap,
                                max: availableMaximum,
                                value: (0,search/* formatWithCommas */.b1)(maxInput).toString().split(".")[0],
                                type: "text",
                                title: "Maximum",
                                onChange: function(e) {
                                    return handleMaxInput(parseInt(e.target.value, 10));
                                },
                                inputMode: "numeric"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/MinMaxNumber/index.ts


;// CONCATENATED MODULE: ./components/search/filters/InitialPayment/InitialPayment.tsx











var InitialPayment = function(param) {
    var filter = param.filter, isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? true : _isMobile;
    var availableInitialMin = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableInitialMin */.KB);
    var availableInitialMax = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableInitialMax */.FI);
    var activeInitialMin = (0,es/* useSelector */.v9)(selectors_search/* selectActiveInitialPaymentMin */.iU);
    var activeInitialMax = (0,es/* useSelector */.v9)(selectors_search/* selectActiveInitialPaymentMax */.bx);
    var includesVat = (0,es/* useSelector */.v9)(selectors_search/* selectIncludeVat */.sw);
    var ref = (0,react.useState)(availableInitialMin), minVal = ref[0], setMinVal = ref[1];
    var ref1 = (0,react.useState)(availableInitialMax >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf ? constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf : availableInitialMax), maxVal = ref1[0], setMaxVal = ref1[1];
    var ref2 = (0,react.useState)(availableInitialMin), minInput = ref2[0], setMinInput = ref2[1];
    var ref3 = (0,react.useState)(availableInitialMax >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf ? constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf : availableInitialMax), maxInput = ref3[0], setMaxInput = ref3[1];
    var minGap = 500;
    var minGapLarge = 2500;
    (0,react.useEffect)(function() {
        if (activeInitialMin && activeInitialMin >= availableInitialMin) {
            var value = activeInitialMin;
            setMinInput(Math.floor(value));
            setMinVal(Math.floor(value));
        }
        if (!activeInitialMin) {
            var value1 = availableInitialMin;
            setMinInput(Math.floor(value1));
            setMinVal(Math.floor(value1));
        }
        // For when the available monthly min is greater than the the active monthly max
        if (activeInitialMax && availableInitialMin >= activeInitialMax && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) {
            var value2 = activeInitialMin;
            setMinInput(Math.floor(value2));
            setMinVal(Math.floor(value2));
        }
    }, [
        activeInitialMin,
        availableInitialMin,
        activeInitialMax
    ]);
    (0,react.useEffect)(function() {
        if (activeInitialMax && activeInitialMax <= availableInitialMax && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) {
            var value = activeInitialMax;
            setMaxInput(value);
            setMaxVal(value);
        }
        if (activeInitialMax && activeInitialMax > availableInitialMax && !activeInitialMin && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) {
            var value1 = constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf;
            setMaxInput(value1);
            setMaxVal(value1);
        }
        // For when the available initial min is greater than the the default monthly max
        if (availableInitialMin >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && activeInitialMax === constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) {
            var value2 = availableInitialMax;
            setMaxInput(Math.floor(value2));
            setMaxVal(Math.floor(value2));
        }
        // if active max is redux default
        if (activeInitialMax === 9999999) {
            var value3 = constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf;
            if (availableInitialMin >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) {
                value3 = availableInitialMax;
            }
            setMaxInput(Math.floor(value3));
            setMaxVal(Math.floor(value3));
        }
    }, [
        activeInitialMin,
        availableInitialMax,
        availableInitialMin,
        activeInitialMax
    ]);
    var onSearch = function(newValue, type) {
        var maxValueToUse = type === "max" ? newValue : maxVal;
        var minValueToUse = type === "min" ? newValue : minVal;
        var amendedValueMax = maxValueToUse === constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf ? 9999999 : includesVat ? (0,search/* removeVatFromPrice */.ae)(maxValueToUse) : maxValueToUse;
        var amendedValueMin = includesVat ? (0,search/* removeVatFromPrice */.ae)(minValueToUse) : minValueToUse;
        if (onChange) {
            if (type === "min") {
                onChange({
                    type: "single",
                    filter: "initialPaymentMin",
                    value: amendedValueMin
                });
            } else {
                onChange({
                    type: "single",
                    filter: "initialPaymentMax",
                    value: amendedValueMax
                });
            }
        }
    };
    var onInitialFinalChange = function(changedValues) {
        slideMin(Number(changedValues[0]));
        onSearch(Number(changedValues[0]), "min");
        slideMax(Number(changedValues[1]));
        onSearch(Number(changedValues[1]), "max");
    };
    var onInitialChange = function(changedValues) {
        slideMin(Number(changedValues[0]));
        slideMax(Number(changedValues[1]));
    };
    var slideMin = function(value) {
        if (value >= availableInitialMin && maxVal - value >= minGap) {
            setMinVal(value);
            setMinInput(Math.floor(value));
        }
    };
    var slideMax = function(value) {
        if (value <= availableInitialMax && value - minVal >= minGap) {
            setMaxVal(value);
            setMaxInput(Math.floor(value));
        }
    };
    var handleMinInput = function(value) {
        var newValue = Number(value) || 0;
        if (newValue >= availableInitialMin && newValue < maxVal - minGap) {
            setMinVal(newValue);
            onSearch(newValue, "min");
        }
        setMinInput(newValue.toFixed(0));
    };
    var handleMaxInput = function(value) {
        var newValue = Number(value) || 0;
        if (newValue <= availableInitialMax && newValue > minVal + minGap) {
            setMaxVal(newValue);
            onSearch(newValue, "max");
        }
        setMaxInput(newValue.toFixed(0));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Total upfront",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: minVal !== availableInitialMin || (availableInitialMin > constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf ? maxVal !== availableInitialMax : maxVal !== constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf),
        maximumNumberOfVisibleSelectedOptions: 1,
        selectedOptions: [
            "".concat(minVal ? (0,search/* filterLabelPrettyName */.p$)(filter, minVal) : "\xa30", "-").concat(maxVal >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && !(activeInitialMin > constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf || activeInitialMax > constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) || maxVal === constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf ? "\xa3".concat((0,search/* formatWithCommas */.b1)(constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf), "+") : (0,search/* filterLabelPrettyName */.p$)(filter, maxVal)), 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_module_default()).Budget,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                        filter: constants/* FILTER_INITIAL_PAYMENT */.Cl,
                        filteredTypeName: constants/* FILTER_INITIAL_PAYMENT */.Cl,
                        availableMinimum: availableInitialMin >= activeInitialMax || activeInitialMin < availableInitialMin ? activeInitialMin : availableInitialMin,
                        availableMaximum: availableInitialMax >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && activeInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && (activeInitialMax <= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf || activeInitialMax >= 9999999) ? constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf : availableInitialMax,
                        activeMinimum: minVal,
                        activeMaximum: maxVal,
                        step: availableInitialMax >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && !(activeInitialMin > constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && activeInitialMax >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf) ? isMobile ? minGap * 0.25 : minGap : isMobile ? minGapLarge * 0.25 : minGapLarge,
                        onChange: onInitialChange,
                        onFinalChange: onInitialFinalChange,
                        isLoading: false,
                        showValues: false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MinMaxNumber, {
                    activeMin: minVal,
                    activeMax: maxVal,
                    handleMinInput: handleMinInput,
                    handleMaxInput: handleMaxInput,
                    minInput: minInput,
                    maxInput: maxInput,
                    availableMaximum: availableInitialMax >= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && availableInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && activeInitialMin < constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf && (activeInitialMax <= constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf || activeInitialMax === 9999999) ? constants/* FILTER_INITIAL_PAYMENT_MAX_DEFAULT */.Qf : availableInitialMax,
                    availableMinimum: availableInitialMin >= activeInitialMax || activeInitialMin < availableInitialMin ? activeInitialMin : availableInitialMin,
                    minGap: minGap,
                    label: constants/* FILTER_INITIAL_PAYMENT */.Cl
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/InitialPayment/index.ts


;// CONCATENATED MODULE: ./components/search/filters/LeaseType/LeaseType.tsx








var LeaseType = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeLeaseType = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchParametersFilterByParameter */.GA)(state, constants/* FILTER_LEASE_TYPES */.LJ);
    });
    var ref = (0,react.useState)(activeLeaseType[0]), localActiveLeaseType = ref[0], setLocalActiveLeaseType = ref[1];
    (0,react.useEffect)(function() {
        setLocalActiveLeaseType(activeLeaseType[0]);
    }, [
        activeLeaseType
    ]);
    var onChangeLeaseType = function(newLeaseType) {
        dispatch((0,reducers_search/* storeSearchParameters */.rq)({
            filter: constants/* FILTER_LEASE_TYPES */.LJ,
            value: [
                newLeaseType
            ]
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_module_default())["filter-row"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((search_module_default()).values, " ").concat((search_module_default()).slider),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "radio",
                    id: "control-1-".concat(isMobile ? "mobile" : "web"),
                    name: "tabs",
                    className: "".concat(localActiveLeaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ ? (search_module_default()).active : "").concat(!(0,utilities_system/* isProd */.BB)() ? " search__filter-personal-input" : ""),
                    value: constants/* FILTER_LEASE_TYPES_PERSONAL */.m_,
                    onChange: function() {
                        return onChangeLeaseType(constants/* FILTER_LEASE_TYPES_PERSONAL */.m_);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: (search_module_default()).tab,
                    onClick: function() {
                        return setLocalActiveLeaseType(constants/* FILTER_LEASE_TYPES_PERSONAL */.m_);
                    },
                    htmlFor: "control-1-".concat(isMobile ? "mobile" : "web"),
                    children: "Personal"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "radio",
                    id: "control-2-".concat(isMobile ? "mobile" : "web"),
                    name: "tabs",
                    className: "".concat(localActiveLeaseType === constants/* FILTER_LEASE_TYPES_BUSINESS */.kG ? (search_module_default()).active : "").concat(!(0,utilities_system/* isProd */.BB)() ? " search__filter-business-input" : ""),
                    value: constants/* FILTER_LEASE_TYPES_BUSINESS */.kG,
                    onChange: function() {
                        return onChangeLeaseType(constants/* FILTER_LEASE_TYPES_BUSINESS */.kG);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: (search_module_default()).tab,
                    onClick: function() {
                        return setLocalActiveLeaseType(constants/* FILTER_LEASE_TYPES_BUSINESS */.kG);
                    },
                    htmlFor: "control-2-".concat(isMobile ? "mobile" : "web"),
                    children: "Business"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (search_module_default()).glider
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/LeaseType/index.ts


;// CONCATENATED MODULE: ./components/search/filters/LegacyMultiSelect/LegacyMultiSelect.tsx









var LegacyMultiSelect = function(param) {
    var filter = param.filter, title = param.title, supportingText = param.supportingText, toggleFilter = param.toggleFilter, _isFilterOpen = param.isFilterOpen, isFilterOpen = _isFilterOpen === void 0 ? false : _isFilterOpen, onChange = param.onChange, _hasAbbreviatedLabels = param.hasAbbreviatedLabels, hasAbbreviatedLabels = _hasAbbreviatedLabels === void 0 ? false : _hasAbbreviatedLabels, _maximumNumberOfVisibleSelectedOptions = param.maximumNumberOfVisibleSelectedOptions, maximumNumberOfVisibleSelectedOptions = _maximumNumberOfVisibleSelectedOptions === void 0 ? 3 : _maximumNumberOfVisibleSelectedOptions;
    var ref = (0,react.useState)([]), mappedSelectedToAvailable = ref[0], setMappedSelectedToAvailable = ref[1];
    var currentlySelectedOptions = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchParametersFilterByParameter */.GA)(state, filter) || [];
    });
    var availableOptions = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchSliceByParameter */.MI)(state, filter) || [];
    });
    (0,react.useEffect)(function() {
        setMappedSelectedToAvailable(function() {
            return availableOptions.filter(function(i) {
                return currentlySelectedOptions.includes(i.id);
            }) || [];
        });
    }, [
        setMappedSelectedToAvailable,
        availableOptions,
        currentlySelectedOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: mappedSelectedToAvailable.length > 0,
        maximumNumberOfVisibleSelectedOptions: maximumNumberOfVisibleSelectedOptions,
        selectedOptions: mappedSelectedToAvailable.length > 0 ? mappedSelectedToAvailable.map(function(i) {
            return (0,search/* filterLabelPrettyName */.p$)(filter, i.name, undefined, hasAbbreviatedLabels);
        }) : [
            "All"
        ],
        children: availableOptions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (search_module_default())["multi-select"],
                    children: availableOptions.map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                            valueAttribute: "id",
                            item: i,
                            isSelected: currentlySelectedOptions.includes(i.id),
                            filter: filter,
                            onChange: onChange,
                            className: !(0,utilities_system/* isProd */.BB)() ? "search__".concat(filter, "-button search__").concat(filter, "-button-").concat((0,search/* filterClassName */.h1)((0,search/* filterLabelPrettyName */.p$)(filter, i.name))) : ""
                        }, i.id);
                    })
                }),
                supportingText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (search_module_default()).supporting,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (search_module_default()).title,
                            children: supportingText.title
                        }),
                        supportingText.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (search_module_default()).subtitle,
                            children: supportingText.subtitle
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "'.concat(title, '" options available based on your current filter selections')
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/LegacyMultiSelect/index.ts


// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
;// CONCATENATED MODULE: ./components/search/filters/Manufacturers/Manufacturers.tsx









var GridButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2695).then(__webpack_require__.bind(__webpack_require__, 2695));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2695)
            ];
        }
    },
    ssr: false
});
var Manufacturers = function(param) {
    var isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange;
    var current = (0,es/* useSelector */.v9)(selectors_search/* selectManufacturersSearchFilter */.Bn);
    var activeManufacturers = (0,es/* useSelector */.v9)(selectors_search/* selectActiveManufacturers */.ZE);
    var ref = (0,react.useState)(false), hasSelections = ref[0], setHasSelections = ref[1];
    var ref1 = (0,react.useState)(12), visibleManufacturers = ref1[0], setVisibleManufacturers = ref1[1];
    (0,react.useEffect)(function() {
        if (activeManufacturers.length > 0) {
            setHasSelections(true);
        } else {
            setHasSelections(false);
        }
    }, [
        activeManufacturers
    ]);
    var onShowMore = function() {
        if (visibleManufacturers === 12) {
            setVisibleManufacturers(current.length);
        } else {
            setVisibleManufacturers(12);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Make",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: hasSelections,
        maximumNumberOfVisibleSelectedOptions: 3,
        selectedOptions: hasSelections ? activeManufacturers.map(function(i) {
            var ref;
            return (ref = current.filter(function(j) {
                return j.id === i;
            })[0]) === null || ref === void 0 ? void 0 : ref.name;
        }).sort(function(a, b) {
            return a.localeCompare(b);
        }) : [
            "All"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: current.slice(0, visibleManufacturers).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (search_module_default()).grid,
                        children: current.slice(0, visibleManufacturers).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridButton, {
                                item: item,
                                onChange: onChange
                            }, item.id);
                        })
                    }),
                    current.length > 12 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: onShowMore,
                        className: (search_module_default())["show-more"],
                        label: "Show ".concat(visibleManufacturers === 12 && current.length > 12 ? "more" : "less"),
                        iconPosition: "right",
                        icon: visibleManufacturers === 12 && current.length > 12 ? "ChevronDown" : "ChevronUp",
                        size: system/* Size.Large */.$u.Large,
                        hasPadding: false,
                        hasUnderline: true,
                        hasBackground: false,
                        hierarchy: Button/* ButtonHierarchy.BorderlessGray */.B.BorderlessGray
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (search_module_default())["error-text"],
                children: 'There are no "Make" options available based on your current filter selections'
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/Manufacturers/index.ts


// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 23 modules
var react_select_esm = __webpack_require__(10015);
;// CONCATENATED MODULE: ./components/search/filters/Models/Models.tsx














var Models_Icon = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Models = function(param) {
    var title = param.title, toggleFilter = param.toggleFilter, _isFilterOpen = param.isFilterOpen, isFilterOpen = _isFilterOpen === void 0 ? false : _isFilterOpen, onChange = param.onChange;
    var selectedRanges = (0,es/* useSelector */.v9)(selectors_search/* selectFullActiveRanges */.j$);
    var availableRanges = (0,es/* useSelector */.v9)(selectors_search/* selectVehicleRanges */.lr);
    var selectedManufacturers = (0,es/* useSelector */.v9)(selectors_search/* selectFullActiveManufacturers */.qt);
    var ref = (0,react.useState)([]), selectedOption = ref[0], setSelectedOption = ref[1];
    var ref1 = (0,react.useState)(true), isFilterDisabled = ref1[0], setIsFilterDisabled = ref1[1];
    (0,react.useEffect)(function() {
        setSelectedOption(selectedRanges || []);
    }, [
        selectedRanges
    ]);
    (0,react.useEffect)(function() {
        if (selectedManufacturers.length === 0 && !isFilterOpen) {
            setIsFilterDisabled(true);
        } else {
            setIsFilterDisabled(false);
        }
    }, [
        selectedManufacturers,
        isFilterOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: title,
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        isFilterDisabled: isFilterDisabled,
        hasSelectedOptions: selectedOption.length > 0,
        selectedOptions: selectedOption.length > 0 ? selectedRanges.map(function(range) {
            return range.name;
        }) : [
            "All"
        ],
        children: selectedManufacturers.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (search_module_default())["models-select-list"],
            children: selectedManufacturers.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            }).map(function(manufacturer) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (search_module_default())["models-select"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (search_module_default()).label,
                            children: manufacturer.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                            isMulti: true,
                            onChange: function(_, event) {
                                if (event.action === "remove-value" || event.action === "pop-value") {
                                    onChange({
                                        value: event.removedValue.value,
                                        type: "multi",
                                        filter: constants/* FILTER_RANGES */.fg
                                    });
                                } else if (event.action === "select-option") {
                                    onChange({
                                        value: event.option.value,
                                        type: "multi",
                                        filter: constants/* FILTER_RANGES */.fg
                                    });
                                }
                            },
                            defaultValue: availableRanges.filter(function(range) {
                                return selectedRanges.includes(range.id) && range.manufacturer === manufacturer.id;
                            }).map(function(range) {
                                return {
                                    value: range.id,
                                    label: range.name
                                };
                            }),
                            placeholder: selectedRanges.filter(function(range) {
                                return range.manufacturer !== manufacturer.id;
                            }).length > 0 ? "None" : "Any",
                            closeMenuOnSelect: false,
                            isClearable: false,
                            classNames: {
                                container: function() {
                                    return (search_module_default())["custom-select"];
                                },
                                control: function(param) {
                                    var isFocused = param.isFocused;
                                    return "".concat((search_module_default()).control, " ").concat(isFocused ? (search_module_default()).focused : "");
                                },
                                multiValue: function() {
                                    return (search_module_default()).chip;
                                },
                                valueContainer: function() {
                                    return (search_module_default())["value-container"];
                                },
                                option: function(param) {
                                    var isFocused = param.isFocused;
                                    return "".concat((search_module_default()).option, " ").concat(isFocused ? (search_module_default()).focused : "", " ").concat(!(0,utilities_system/* isProd */.BB)() ? "search__models-option search__models-option-" + (0,search/* filterClassName */.h1)(manufacturer.name) : "");
                                },
                                indicatorsContainer: function() {
                                    return (search_module_default())["indicators-container"];
                                },
                                input: function() {
                                    return "".concat((search_module_default())["select-input"]).concat(!(0,utilities_system/* isProd */.BB)() ? " search__models-input" : "");
                                },
                                placeholder: function() {
                                    return (search_module_default())["select-placeholder"];
                                }
                            },
                            components: {
                                IndicatorSeparator: function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                },
                                MultiValueLabel: function(param) {
                                    var children = param.children;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: children
                                    });
                                },
                                MultiValueRemove: function(param) {
                                    var innerProps = param.innerProps;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                                        className: (search_module_default()).remove,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Models_Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                                            name: "X",
                                            size: system/* Size.Medium */.$u.Medium
                                        }))
                                    }));
                                },
                                DropdownIndicator: function(param) {
                                    var innerProps = param.innerProps;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Models_Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                                        name: "ChevronDown",
                                        size: system/* Size.Medium */.$u.Medium
                                    }));
                                }
                            },
                            options: availableRanges.filter(function(range) {
                                return range.manufacturer === manufacturer.id;
                            }).map(function(range) {
                                return {
                                    value: range.id,
                                    label: range.name
                                };
                            })
                        })
                    ]
                }, manufacturer.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (search_module_default())["error-text"],
            children: 'There are no "Models" options available based on your current filter selections'
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/Models/index.ts


;// CONCATENATED MODULE: ./components/search/filters/MonthlyPrice/MonthlyPrice.tsx











var MonthlyPrice = function(param) {
    var filter = param.filter, isFilterOpen = param.isFilterOpen, toggleFilter = param.toggleFilter, onChange = param.onChange, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? true : _isMobile;
    var availableMonthlyMin = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableMonthlyMin */.vu);
    var availableMonthlyMax = (0,es/* useSelector */.v9)(selectors_search/* selectAvailableMonthlyMax */.Un);
    var activeMonthlyMin = (0,es/* useSelector */.v9)(selectors_search/* selectActiveMonthlyMin */.G0);
    var activeMonthlyMax = (0,es/* useSelector */.v9)(selectors_search/* selectActiveMonthlyMax */.Ch);
    var includesVat = (0,es/* useSelector */.v9)(selectors_search/* selectIncludeVat */.sw);
    var ref = (0,react.useState)(availableMonthlyMin), minVal = ref[0], setMinVal = ref[1];
    var ref1 = (0,react.useState)(availableMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD : availableMonthlyMax), maxVal = ref1[0], setMaxVal = ref1[1];
    var ref2 = (0,react.useState)(activeMonthlyMin && activeMonthlyMin >= availableMonthlyMin ? activeMonthlyMin : availableMonthlyMin), minInput = ref2[0], setMinInput = ref2[1];
    var ref3 = (0,react.useState)(availableMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD : availableMonthlyMax), maxInput = ref3[0], setMaxInput = ref3[1];
    var minGap = 50;
    var minGapLarge = 250;
    (0,react.useEffect)(function() {
        if (activeMonthlyMin && activeMonthlyMin >= availableMonthlyMin) {
            var value = activeMonthlyMin;
            setMinInput(Math.floor(value));
            setMinVal(Math.floor(value));
        }
        if (!activeMonthlyMin) {
            var value1 = availableMonthlyMin;
            setMinInput(Math.floor(value1));
            setMinVal(Math.floor(value1));
        }
        // For when the available monthly min is greater than the the active monthly max
        if (activeMonthlyMax && availableMonthlyMin >= activeMonthlyMax && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) {
            var value2 = activeMonthlyMin;
            setMinInput(Math.floor(value2));
            setMinVal(Math.floor(value2));
        }
    }, [
        activeMonthlyMin,
        availableMonthlyMin,
        activeMonthlyMax
    ]);
    (0,react.useEffect)(function() {
        if (activeMonthlyMax && activeMonthlyMax <= availableMonthlyMax && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) {
            var value = activeMonthlyMax;
            setMaxInput(value);
            setMaxVal(value);
        }
        if (activeMonthlyMax && activeMonthlyMax > availableMonthlyMax && !activeMonthlyMin && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) {
            var value1 = constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD;
            setMaxInput(value1);
            setMaxVal(value1);
        }
        // For when the available monthly min is greater than the the default monthly max
        if (availableMonthlyMin >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && activeMonthlyMax === constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) {
            var value2 = availableMonthlyMax;
            setMaxInput(Math.floor(value2));
            setMaxVal(Math.floor(value2));
        }
        // if active max is redux default
        if (activeMonthlyMax === 9999999) {
            var value3 = constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD;
            if (availableMonthlyMin >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) {
                value3 = availableMonthlyMax;
            }
            setMaxInput(Math.floor(value3));
            setMaxVal(Math.floor(value3));
        }
    }, [
        activeMonthlyMin,
        availableMonthlyMax,
        availableMonthlyMin,
        activeMonthlyMax
    ]);
    var onSearch = function(newValue, type) {
        var maxValueToUse = type === "max" ? newValue : maxVal;
        var minValueToUse = type === "min" ? newValue : minVal;
        var amendedValueMax = maxValueToUse === constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? 9999999 : includesVat ? (0,search/* removeVatFromPrice */.ae)(maxValueToUse) : maxValueToUse;
        var amendedValueMin = includesVat ? (0,search/* removeVatFromPrice */.ae)(minValueToUse) : minValueToUse;
        if (onChange) {
            if (type === "min") {
                onChange({
                    type: "single",
                    filter: "monthlyPaymentMin",
                    value: amendedValueMin
                });
            } else {
                onChange({
                    type: "single",
                    filter: "monthlyPaymentMax",
                    value: amendedValueMax
                });
            }
        }
    };
    var onMonthlyFinalChange = function(changedValues) {
        slideMin(Number(changedValues[0]));
        onSearch(Number(changedValues[0]), "min");
        slideMax(Number(changedValues[1]));
        onSearch(Number(changedValues[1]), "max");
    };
    var onMonthlyChange = function(changedValues) {
        slideMin(Number(changedValues[0]));
        slideMax(Number(changedValues[1]));
    };
    var slideMin = function(value) {
        if (value >= availableMonthlyMin && maxVal - value >= minGap) {
            setMinVal(value);
            setMinInput(Math.floor(value));
        }
    };
    var slideMax = function(value) {
        if (value <= availableMonthlyMax && value - minVal >= minGap) {
            setMaxVal(value);
            setMaxInput(Math.floor(value));
        }
    };
    var handleMinInput = function(value) {
        var newValue = Number(value) || 0;
        if (newValue >= availableMonthlyMin && newValue < maxVal - minGap) {
            setMinVal(newValue);
            onSearch(newValue, "min");
        }
        setMinInput(newValue.toFixed(0));
    };
    var handleMaxInput = function(value) {
        var newValue = Number(value) || 0;
        if (newValue <= availableMonthlyMax && newValue > minVal + minGap) {
            setMaxVal(newValue);
            onSearch(newValue, "max");
        }
        setMaxInput(newValue.toFixed(0));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Monthly price",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: minVal !== availableMonthlyMin || (availableMonthlyMin > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? maxVal !== availableMonthlyMax : maxVal !== constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD),
        maximumNumberOfVisibleSelectedOptions: 1,
        selectedOptions: [
            "".concat(minVal ? (0,search/* filterLabelPrettyName */.p$)(filter, minVal) : "\xa30", "-").concat(maxVal >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && !(activeMonthlyMin > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD || activeMonthlyMax > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) || maxVal === constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD ? "\xa3".concat((0,search/* formatWithCommas */.b1)(constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD), "+") : (0,search/* filterLabelPrettyName */.p$)(filter, maxVal)), 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (search_module_default()).Budget,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Range, {
                        filter: constants/* FILTER_MONTHLY_PAYMENT */.cF,
                        filteredTypeName: constants/* FILTER_MONTHLY_PAYMENT */.cF,
                        availableMinimum: availableMonthlyMin >= activeMonthlyMax || activeMonthlyMin < availableMonthlyMin ? activeMonthlyMin : availableMonthlyMin,
                        availableMaximum: availableMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && activeMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && (activeMonthlyMax <= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD || activeMonthlyMax === 9999999) ? constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD : availableMonthlyMax,
                        activeMinimum: minVal,
                        activeMaximum: maxVal,
                        step: availableMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && !(activeMonthlyMin > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && activeMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) ? isMobile ? minGap * 0.25 : minGap : isMobile ? minGapLarge * 0.25 : minGapLarge,
                        onChange: onMonthlyChange,
                        onFinalChange: onMonthlyFinalChange,
                        isLoading: false,
                        showValues: false
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MinMaxNumber, {
                    activeMin: minVal,
                    activeMax: maxVal,
                    handleMinInput: handleMinInput,
                    handleMaxInput: handleMaxInput,
                    minInput: minInput,
                    maxInput: maxInput,
                    availableMaximum: availableMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && availableMonthlyMin < constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && !(activeMonthlyMin > constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD && activeMonthlyMax >= constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD) ? constants/* FILTER_MONTHLY_PAYMENT_MAX_DEFAULT */.cD : availableMonthlyMax,
                    availableMinimum: availableMonthlyMin >= activeMonthlyMax ? activeMonthlyMin : availableMonthlyMin,
                    minGap: minGap,
                    label: constants/* FILTER_MONTHLY_PAYMENT */.cF
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/MonthlyPrice/index.ts


// EXTERNAL MODULE: ./components/search/filters/SortBy/sort-by.module.scss
var sort_by_module = __webpack_require__(7457);
var sort_by_module_default = /*#__PURE__*/__webpack_require__.n(sort_by_module);
// EXTERNAL MODULE: ./components/search/inputs/Radio/radio.module.scss
var radio_module = __webpack_require__(42114);
var radio_module_default = /*#__PURE__*/__webpack_require__.n(radio_module);
;// CONCATENATED MODULE: ./components/search/inputs/Radio/Radio.tsx


var Radio = function(param) {
    var label = param.label, value = param.value, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (radio_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (radio_module_default()).input,
                type: "radio",
                id: label,
                name: label,
                value: value,
                checked: isActive,
                onChange: onChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (radio_module_default()).label,
                htmlFor: label,
                children: label
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/Radio/index.ts


;// CONCATENATED MODULE: ./components/search/filters/SortBy/SortBy.tsx









var SortBy = function(param) {
    var toggleFilter = param.toggleFilter, _isFilterOpen = param.isFilterOpen, isFilterOpen = _isFilterOpen === void 0 ? false : _isFilterOpen;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeSortBy = (0,es/* useSelector */.v9)(selectors_search/* selectSortBy */.C9);
    var ref = (0,react.useState)(activeSortBy), selectedOption = ref[0], setSelectedOption = ref[1];
    var onChangeSortBy = function(sortId) {
        dispatch((0,reducers_search/* storeSearchParameters */.rq)({
            filter: "sortBy",
            value: Number(sortId)
        }));
    };
    var getSortByPrettyName = function(value) {
        switch(value){
            case 1:
                return "Best value";
            case 2:
                return "Price (low to high)";
            case 3:
                return "Least value";
            case 4:
                return "Price (high to low)";
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDropdown/* FilterDropdown */.M, {
        title: "Sort by",
        toggleFilter: toggleFilter,
        isFilterOpen: isFilterOpen,
        hasSelectedOptions: true,
        hasSpacingBottom: false,
        selectedOptions: [
            getSortByPrettyName(activeSortBy) || constants/* constants.searchSortingOptions.VALUE_HIGH_TO_LOW.label */._G.searchSortingOptions.VALUE_HIGH_TO_LOW.label, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (sort_by_module_default()).options,
            tabIndex: -1,
            role: "list",
            children: Object.keys(constants/* constants.searchSortingOptions */._G.searchSortingOptions).map(function(item) {
                var value = constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                        label: getSortByPrettyName(value),
                        value: value,
                        isActive: selectedOption === value,
                        onChange: function() {
                            setSelectedOption(value);
                            onChangeSortBy(value);
                        }
                    })
                }, item);
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/search/filters/SortBy/index.ts


// EXTERNAL MODULE: ./components/search/inputs/TextSearch/index.ts + 2 modules
var TextSearch = __webpack_require__(24313);
;// CONCATENATED MODULE: ./components/search/inputs/Toggle/Toggle.tsx




var Toggle = function(param) {
    var parameter = param.parameter, title = param.title, subtitle = param.subtitle, _className = param.className, className = _className === void 0 ? "" : _className, activeFilterValue = param.activeFilterValue, inactiveFilterValue = param.inactiveFilterValue, onChange = param.onChange;
    var current = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_search/* selectSearchParametersFilterByParameter */.GA)(state, parameter);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).toggle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (search_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).title,
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).subtitle,
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "data-is-selected": current === activeFilterValue,
                title: title,
                type: "button",
                onClick: function() {
                    onChange({
                        type: "single",
                        filter: parameter,
                        value: current === activeFilterValue ? inactiveFilterValue : activeFilterValue
                    });
                },
                className: "".concat((search_module_default())["toggle-component"], " ").concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (search_module_default())["dial--wrap"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (search_module_default()).dial
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/Toggle/index.ts


// EXTERNAL MODULE: ./store/selectors/user.js
var user = __webpack_require__(15433);
;// CONCATENATED MODULE: ./components/search/saved-search/LoadTrigger.tsx








var AuthenticationModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5808), __webpack_require__.e(9161), __webpack_require__.e(3418), __webpack_require__.e(9538)]).then(__webpack_require__.bind(__webpack_require__, 93418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93418)
            ];
        }
    },
    ssr: false
});
var LoadModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4435), __webpack_require__.e(6813)]).then(__webpack_require__.bind(__webpack_require__, 76813));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76813)
            ];
        }
    },
    ssr: false
});
var LoadTrigger = function(param) {
    var setIsMobileFiltersOpen = param.setIsMobileFiltersOpen;
    var isAuthenticated = (0,es/* useSelector */.v9)(user/* selectIsAuthenticated */.vN);
    var onLoadSearchesClick = function() {
        if (setIsMobileFiltersOpen) {
            setIsMobileFiltersOpen(false);
        }
        if (isAuthenticated) {
            esm/* default.show */.ZP.show(LoadModal);
        } else {
            esm/* default.show */.ZP.show(AuthenticationModal);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
        size: system/* Size.Medium */.$u.Medium,
        hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
        label: "Your saved searches",
        icon: "ArrowRight",
        iconPosition: "right",
        onClick: onLoadSearchesClick,
        className: !(0,utilities_system/* isProd */.BB)() ? "search__your-searches-button" : ""
    });
};

// EXTERNAL MODULE: ./components/search/saved-search/SaveTrigger.tsx
var SaveTrigger = __webpack_require__(30522);
;// CONCATENATED MODULE: ./components/search/SearchFilters/SearchFilters.tsx








































var MultiSelect = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7913).then(__webpack_require__.bind(__webpack_require__, 97913));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97913)
            ];
        }
    },
    ssr: false
});
var Select = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1283).then(__webpack_require__.bind(__webpack_require__, 1283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1283)
            ];
        }
    },
    ssr: false
});
var SelectFromRange = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 567).then(__webpack_require__.bind(__webpack_require__, 10567));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10567)
            ];
        }
    },
    ssr: false
});
var SearchFilters_AuthenticationModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5808), __webpack_require__.e(9161), __webpack_require__.e(3418), __webpack_require__.e(9538)]).then(__webpack_require__.bind(__webpack_require__, 93418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93418)
            ];
        }
    },
    ssr: false
});
var SearchFilters = function(param) {
    var isMobile = param.isMobile, setIsMobileFiltersOpen = param.setIsMobileFiltersOpen, setVisibleFilters = param.setVisibleFilters, toggleFilter = param.toggleFilter, toggleId = param.toggleId, setToggleId = param.setToggleId, _isVans = param.isVans, isVans = _isVans === void 0 ? false : _isVans, _visibleFilters = param.visibleFilters, visibleFilters = _visibleFilters === void 0 ? [] : _visibleFilters;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var filterCount = (0,es/* useSelector */.v9)(selectors_search/* selectCountOfSearchParameters */.F_);
    var isAuthenticated = (0,es/* useSelector */.v9)(user/* selectIsAuthenticated */.vN);
    var search = (0,es/* useSelector */.v9)(selectors_search/* selectSearchUpdate */.K3);
    var prevSearchRef = (0,react.useRef)(search);
    (0,react.useEffect)(function() {
        if (prevSearchRef.current !== search) {
            if (toggleId && !visibleFilters.includes(toggleId)) {
                setVisibleFilters(function(prev) {
                    return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        toggleId
                    ]);
                });
                setToggleId("");
            }
            prevSearchRef.current = search;
        }
    }, [
        search,
        toggleId,
        visibleFilters,
        setVisibleFilters,
        setToggleId
    ]);
    var removeDuplicatePrefixFilters = function(array) {
        var prefixMap = {};
        return array.filter(function(filter) {
            var ref = (0,_sliced_to_array/* default */.Z)(filter.split("-"), 1), prefix = ref[0];
            if (prefixMap[prefix] === undefined) {
                prefixMap[prefix] = 1;
                return true;
            } else {
                prefixMap[prefix]++;
                return false;
            }
        });
    };
    var onFilterChange = function(param) {
        var type = param.type, filter = param.filter, value = param.value, isGrouped = param.isGrouped, vehiclePriceTag = param.vehiclePriceTag;
        var ref;
        var visibleFiltersWithoutDuplicates = removeDuplicatePrefixFilters(visibleFilters);
        if (type === "multi") {
            dispatch((0,reducers_search/* storeSearchMultiParameters */.Bn)({
                filter: filter,
                value: value,
                visibleFilters: visibleFiltersWithoutDuplicates
            }));
        } else if (type === "single") {
            dispatch((0,reducers_search/* storeSearchParameters */.rq)({
                filter: filter,
                value: value,
                visibleFilters: visibleFiltersWithoutDuplicates
            }));
        } else if (type === "vehiclePriceTag") {
            if (isGrouped) {
                dispatch((0,reducers_search/* toggleGroupedVehiclePriceTag */.Mi)({
                    vehiclePriceTagCategoryId: vehiclePriceTag === null || vehiclePriceTag === void 0 ? void 0 : vehiclePriceTag.category,
                    visibleFilters: visibleFiltersWithoutDuplicates
                }));
            } else {
                dispatch((0,reducers_search/* storeUngroupedVehiclePriceTag */.EH)({
                    visibleFilters: visibleFiltersWithoutDuplicates,
                    category: vehiclePriceTag === null || vehiclePriceTag === void 0 ? void 0 : vehiclePriceTag.category,
                    tag: vehiclePriceTag === null || vehiclePriceTag === void 0 ? void 0 : vehiclePriceTag.tag
                }));
            }
        }
        if (router.asPath.includes("page=")) {
            var isVans = router.asPath.includes("van-leasing");
            router.push("/".concat(isVans ? "van" : "car", "-leasing/search"), undefined, {
                scroll: false
            });
        }
        var searchToolbar = document.querySelector(".search__container");
        // only scrolls if below toolbar
        if (((ref = searchToolbar === null || searchToolbar === void 0 ? void 0 : searchToolbar.getBoundingClientRect()) === null || ref === void 0 ? void 0 : ref.y) < 0) {
            searchToolbar === null || searchToolbar === void 0 ? void 0 : searchToolbar.scrollIntoView({
                behavior: "smooth",
                inline: "start"
            });
        }
    };
    var generateFilterProps = function(filter, typeName) {
        var filterName = "".concat(filter).concat(typeName ? "-".concat(typeName) : "");
        return {
            onChange: onFilterChange,
            filter: filter,
            toggleFilter: function() {
                return toggleFilter(filterName);
            },
            isFilterOpen: visibleFilters.includes(filterName),
            typeName: typeName
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_module_default()).filters,
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (search_module_default()).title,
                        children: "Filters"
                    }),
                    filterCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        size: system/* Size.Small */.$u.Small,
                        hasBackground: false,
                        hierarchy: Button/* ButtonHierarchy.Borderless */.B.Borderless,
                        hasUnderline: true,
                        label: "Clear (".concat(filterCount, ")"),
                        onClick: function() {
                            setVisibleFilters([]);
                            dispatch((0,reducers_search/* clearAllSearchState */.xs)());
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterPackage, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                        hasBorderBottom: !isMobile,
                        children: isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (search_module_default())["saved-search-container"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadTrigger, {
                                    setIsMobileFiltersOpen: setIsMobileFiltersOpen
                                }),
                                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveTrigger/* SaveTrigger */.N, {
                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: "".concat((search_module_default())["guest-save-search"], " ").concat(!(0,utilities_system/* isProd */.BB)() ? " search__login-button" : ""),
                            onClick: function() {
                                if (setIsMobileFiltersOpen) {
                                    setIsMobileFiltersOpen(false);
                                }
                                esm/* default.show */.ZP.show(SearchFilters_AuthenticationModal);
                            },
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (search_module_default()).desktop,
                                        children: "Log in to save"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (search_module_default()).mobile,
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "search"
                                    })
                                ]
                            }),
                            hierarchy: Button/* ButtonHierarchy.Bezeled */.B.Bezeled,
                            icon: "ArrowRight",
                            size: system/* Size.Large */.$u.Large,
                            iconPosition: "right"
                        })
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                        hasBorderBottom: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSearch/* TextSearch */.N, {
                            visibleFilters: visibleFilters,
                            isVans: isVans,
                            isMobile: false
                        })
                    }),
                    !isVans && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                        hasBorderBottom: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaseType, {
                            isMobile: isMobile
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                        hasBorderBottom: isMobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                                activeFilterValue: 1,
                                inactiveFilterValue: 0,
                                parameter: "inStock",
                                onChange: onFilterChange,
                                title: "In stock only",
                                subtitle: "Only see vehicles that are available for quick delivery.",
                                className: !(0,utilities_system/* isProd */.BB)() ? " search__in-stock-toggle" : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                                activeFilterValue: 3,
                                inactiveFilterValue: 1,
                                parameter: "grouping",
                                title: "Group vehicle by model",
                                subtitle: "Only show the best deal for each model.",
                                onChange: onFilterChange,
                                className: !(0,utilities_system/* isProd */.BB)() ? " search__group-model-toggle" : ""
                            })
                        ]
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                        hasBorderBottom: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SortBy, (0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_SORT_BY */.NK)))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Lease details",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthlyPrice, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_MONTHLY_PAYMENT */.cF)), {
                            isMobile: isMobile
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialPayment, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_INITIAL_PAYMENT */.Cl)), {
                            isMobile: isMobile
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Mileage per annum",
                            hasAbbreviatedLabels: true
                        }, generateFilterProps(constants/* FILTER_MILEAGES */.Og))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Term",
                            hasAbbreviatedLabels: true
                        }, generateFilterProps(constants/* FILTER_TERMS */.Hx))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableVehiclePriceTagsMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Delivery time"
                        }, generateFilterProps(constants/* FILTER_DELIVERY */.qU)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Make & model",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Manufacturers, (0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_MANUFACTURERS */.Gz))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Models, (0,_object_spread/* default */.Z)({
                            title: "Model"
                        }, generateFilterProps(constants/* FILTER_RANGES */.fg)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Fuel & drive",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Fuel"
                        }, generateFilterProps(constants/* FILTER_FUEL_TYPES */.pF))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Transmission"
                        }, generateFilterProps(constants/* FILTER_TRANSMISSION_TYPES */.dw))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Drive",
                            maximumNumberOfVisibleSelectedOptions: 1,
                            hasAbbreviatedLabels: true
                        }, generateFilterProps(constants/* FILTER_DRIVE_TYPES */.Jw)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Body type & accessibility",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Body type"
                        }, generateFilterProps(constants/* FILTER_BODY_STYLES */.EK))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Seats"
                        }, generateFilterProps(constants/* FILTER_SEATS */.W2))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Doors"
                        }, generateFilterProps(constants/* FILTER_DOORS */.p_))),
                        !isVans && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Bootspace"
                        }, generateFilterProps(constants/* FILTER_BOOT_SPACE */.Ge)))
                    ]
                })
            }),
            !isVans && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Battery",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectFromRange, (0,_object_spread/* default */.Z)({
                            title: "Battery range",
                            type: "min",
                            supportingText: {
                                title: "This is roughly how far the car can drive on a single full charge.",
                                subtitle: "According to WLTP (Worldwide Harmonized Light Vehicles Test Procedure)"
                            }
                        }, generateFilterProps(constants/* FILTER_ELECTRIC_RANGE */.EH))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectricFilterMinMax, (0,_object_spread/* default */.Z)({
                            title: "Fastest charge rate"
                        }, generateFilterProps(constants/* FILTER_ELECTRIC_FASTEST_CHARGE_RATE */.V2))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectFromRange, (0,_object_spread/* default */.Z)({
                            title: "Home charge time",
                            type: "max",
                            hasAbbreviatedLabels: true,
                            supportingText: {
                                title: "This is how long the car will take to fully charge using a charging point (7.4kW)"
                            }
                        }, generateFilterProps(constants/* FILTER_ELECTRIC_HOME_CHARGE_TIME */.zc))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ElectricFilterMinMax, (0,_object_spread/* default */.Z)({
                            title: "Battery size"
                        }, generateFilterProps(constants/* FILTER_ELECTRIC_BATTERY_CAPACITY */.Bc)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Engine",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, (0,_object_spread/* default */.Z)({
                            title: "CO2"
                        }, generateFilterProps(constants/* FILTER_PERFORMANCE */.UF, "MAX_CO2"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, (0,_object_spread/* default */.Z)({
                            title: "MPG"
                        }, generateFilterProps(constants/* FILTER_PERFORMANCE */.UF, "MIN_MPG"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EngineSize, (0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_PERFORMANCE */.UF, "MAX_ENGINE")))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Additional specification",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, (0,_object_spread/* default */.Z)({
                            title: "0-62"
                        }, generateFilterProps(constants/* FILTER_PERFORMANCE */.UF, "MAX_MPH062"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Alloys, (0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_SPEC */.q9, "ALLOYS"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComfortAndSafety, (0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_SPEC */.q9, "COMFORT"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Convenience, (0,_object_spread/* default */.Z)({}, generateFilterProps(constants/* FILTER_SPEC */.q9, "CONVENIENCE")))
                    ]
                })
            }),
            isVans && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategory, {
                    header: "Size & shape",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Capacity, (0,_object_spread/* default */.Z)({
                            title: "Capacity"
                        }, generateFilterProps(constants/* FILTER_CAPACITY */.gI))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Wheelbase",
                            hasAbbreviatedLabels: true
                        }, generateFilterProps(constants/* FILTER_WHEELBASE */.cA))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LegacyMultiSelect, (0,_object_spread/* default */.Z)({
                            title: "Roof height",
                            hasAbbreviatedLabels: true
                        }, generateFilterProps(constants/* FILTER_ROOF_HEIGHT */.aW))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, (0,_object_spread/* default */.Z)({
                            title: "Cab"
                        }, generateFilterProps(constants/* FILTER_FEATURES */.Ls, constants/* FILTER_FEATURES_CAB */.DZ))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, (0,_object_spread/* default */.Z)({
                            title: "Flatbed"
                        }, generateFilterProps(constants/* FILTER_FEATURES */.Ls, constants/* FILTER_FEATURES_FLATBED */.BR))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, (0,_object_spread/* default */.Z)({
                            title: "Side panels"
                        }, generateFilterProps(constants/* FILTER_FEATURES */.Ls, constants/* FILTER_FEATURES_SIDE_PANELS */.Nq)))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPackage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                    hasBorderBottom: false,
                    header: "Add ons",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableVehiclePriceTagsMultiSelect, (0,_object_spread/* default */.Z)({
                        title: "Inclusive benefits"
                    }, generateFilterProps(constants/* FILTER_INCLUSIVE_BENEFITS */.s9)))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/SearchFilters/index.ts



/***/ }),

/***/ 24542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18149);
/* harmony import */ var _components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_utilities_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45425);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16693);





var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var Checkbox = function(param) {
    var item = param.item, valueAttribute = param.valueAttribute, filter = param.filter, resultCount = param.resultCount, isSelected = param.isSelected, onChange = param.onChange, _type = param.type, type = _type === void 0 ? "multi" : _type, _showResultCount = param.showResultCount, showResultCount = _showResultCount === void 0 ? true : _showResultCount, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: "".concat((_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item), " ").concat(className),
        type: "button",
        disabled: resultCount === 0,
        onClick: function() {
            onChange({
                type: type,
                filter: filter,
                value: item[valueAttribute]
            });
        },
        "data-is-selected": isSelected,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: (_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default().label),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
                        children: (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_2__/* .filterLabelPrettyName */ .p$)(filter, item.displayName ? item.displayName : item.name)
                    }),
                    item.supporting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default().supporting),
                        children: item.supporting
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default().box),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    name: "Check",
                    size: _types_system__WEBPACK_IMPORTED_MODULE_3__/* .Size.Small */ .$u.Small,
                    customClass: (_components_search_search_module_scss__WEBPACK_IMPORTED_MODULE_4___default().check)
                })
            })
        ]
    }, item.name);
};


/***/ }),

/***/ 20237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _Checkbox__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24542);



/***/ }),

/***/ 56244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/lucide-react.js
var lucide_react = __webpack_require__(14358);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Icon/Icon.tsx



var Icon = function(param) {
    var name = param.name, size = param.size, customClass = param.customClass;
    var ChosenIcon = lucide_react[name];
    var calculatedSize = 16;
    if (size === system/* Size.ExtraSmall */.$u.ExtraSmall) {
        calculatedSize = 10;
    }
    if (size === system/* Size.Medium */.$u.Medium) {
        calculatedSize = 20;
    }
    if (size === system/* Size.Large */.$u.Large) {
        calculatedSize = 24;
    }
    if (size === system/* Size.ExtraLarge */.$u.ExtraLarge) {
        calculatedSize = 28;
    }
    if (size === system/* Size.ExtraExtraLarge */.$u.ExtraExtraLarge) {
        calculatedSize = 40;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChosenIcon, {
        className: customClass ? customClass : "",
        size: calculatedSize
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Icon/index.ts



/***/ }),

/***/ 55123:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliders":"capacity_sliders__dMsUx","row":"capacity_row__YDirS","title":"capacity_title__0dxoI","phAnimation":"capacity_phAnimation__Euzhb"};

/***/ }),

/***/ 62599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"no-margin":"comfort-and-safety_no-margin__gf_hT","phAnimation":"comfort-and-safety_phAnimation__891NS"};

/***/ }),

/***/ 7457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"options":"sort-by_options__g6KkO","phAnimation":"sort-by_phAnimation__lOH4E"};

/***/ }),

/***/ 42114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"radio_container__ZOIii","label":"radio_label__c8gx_","input":"radio_input__tdnN5","phAnimation":"radio_phAnimation__Zf3Ae"};

/***/ }),

/***/ 69113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"range":"range_range__4MPN2","has-margin":"range_has-margin__Kt8Kl","values":"range_values__1SOAZ","phAnimation":"range_phAnimation__Aphue"};

/***/ }),

/***/ 18149:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filters":"search_filters__WQigF","header":"search_header__vkN6Q","title":"search_title__34U0u","clear-button":"search_clear-button__v6pBA","guest-save-search":"search_guest-save-search__8KQrL","desktop":"search_desktop__w5FDe","mobile":"search_mobile__kInr8","saved-search-container":"search_saved-search-container__S2NMo","category":"search_category__SKef2","with-border":"search_with-border__UQ5Pv","icon":"search_icon__XTSBX","filter":"search_filter__Cfvvq","supporting-text":"search_supporting-text__tUXKs","subtitle":"search_subtitle__OwZZf","error-text":"search_error-text__u3r_b","chevron":"search_chevron__nUiQF","text":"search_text__SRvRo","name":"search_name__pxDPN","selected":"search_selected__WNwmc","content":"search_content__mXVEQ","input-wrapper":"search_input-wrapper__s_AQV","adornment":"search_adornment__IXdYy","input":"search_input__wXbQw","minmax":"search_minmax___GRrf","label":"search_label__tcu_G","selects":"search_selects__yb2aV","select":"search_select__PW_hI","multi-select":"search_multi-select__YUrAq","sub-filter-header":"search_sub-filter-header__muhqH","item":"search_item__TtRR0","count":"search_count__QIwBN","box":"search_box__hBWIO","supporting":"search_supporting__iPhK8","check":"search_check__0TRVH","switch":"search_switch__rMKbw","option":"search_option__3OmLm","toggle":"search_toggle__brq1d","toggle-component":"search_toggle-component__dTeOF","dial--wrap":"search_dial--wrap__nkFuD","dial":"search_dial__t97QO","show-more":"search_show-more__HFnJN","grid":"search_grid___f9fs","image":"search_image__TxdP4","control":"search_control__mhgz9","compact":"search_compact__ciYRW","default-selected":"search_default-selected__OMY_U","main":"search_main__ra6kX","values":"search_values__XX8Em","models-select":"search_models-select__Udqfs","models-select-list":"search_models-select-list__l3YX1","collapsible":"search_collapsible__ZNRqM","custom-select":"search_custom-select__P2G9I","focused":"search_focused__rWypJ","select-input":"search_select-input__iCxwp","select-placeholder":"search_select-placeholder__xuqlb","chip":"search_chip__X6L8g","remove":"search_remove__plx3y","value-container":"search_value-container__pYAZZ","filter-row":"search_filter-row__a5U1W","slider":"search_slider__vZsOd","glider":"search_glider__1RnYB","active":"search_active___hJss","tab":"search_tab__6V78z","package":"search_package__tUkgg","phAnimation":"search_phAnimation__zKzjH"};

/***/ })

}]);